{
  "unavailable": {
    "requestTitle": "Demande indisponible",
    "requestDescription": "Cette demande n’est plus disponible. Elle a peut-être été supprimée ou le lien est incorrect.",
    "requestAction": "Voir mes demandes",
    "budgetTitle": "Devis indisponible",
    "budgetDescription": "Ce devis n’est plus disponible. Il a peut-être été supprimé ou le lien est incorrect.",
    "budgetAction": "Voir les devis"
  },
  "identityCandidates": {
    "title": "Alternatives proposées par Atlas",
    "choose": "Sélectionner ce produit",
    "searchLabel": "Code, référence, marque ou texte visible",
    "search": "Rechercher avec Atlas",
    "reviewPending": "Atlas n’a pas pu identifier le produit à partir de ce qu’il a lu dans le document. Il faut corriger le code, la référence, la marque ou la description tels qu’ils figurent dans le document.",
    "pendingTitle": "Identification en cours",
    "identityPending": "Atlas n’a pas encore publié l’étape suivante pour identifier ce produit.",
    "readValues": "Ce qu’Atlas a lu dans le document :",
    "askAgainHint": "Interrogez à nouveau Atlas pour ouvrir le formulaire et continuer.",
    "askAgain": "Interroger à nouveau Atlas",
    "correctTitle": "Corriger la lecture",
    "correctHint": "Corrigez uniquement les données visibles dans le document. Atlas relancera la recherche sans modifier la quantité ni l’unité.",
    "confirmCorrection": "Confirmer la correction",
    "fields": {
      "source_code": "Code lu",
      "source_reference": "Référence lue",
      "source_brand": "Marque lue",
      "source_description": "Description lue",
      "raw_text": "Texte complet lu"
    },
    "selecting": "Sélection en cours…"
  },
  "documentQuantity": {
    "commercialPending": "Révision commerciale de l’unité d’achat",
    "commercialHint": "L’équipe commerciale confirmera comment ces produits sont achetés : {{products}}. Vous n’avez rien à faire : vous pouvez continuer et ils seront envoyés signalés pour cette révision.",
    "pending": "Confirmez les quantités en attente avant de continuer. Les autres produits ne nécessitent pas cette vérification.",
    "review": "Vérifier la quantité",
    "missing": "Quantité à indiquer"
  },
  "admin": {
    "atlasSkills": {
      "title": "État Atlas et lecteurs",
      "refresh": "Vérifier",
      "hint": "Les données API, les preuves de lecture du Portail et les skills sont vérifiées séparément.",
      "installedVersion": "Installée",
      "activeVersion": "Active dans Atlas",
      "latestVersion": "Dernière version communiquée par Atlas",
      "channel": "Canal disponible",
      "unknownValue": "Non confirmé",
      "checked": "Dernière consultation : {{date}}",
      "observed": "Inventaire Atlas : {{date}}",
      "empty": "Atlas a confirmé un inventaire vide.",
      "noVisibleSkills": "Aucune skill à afficher dans cette section du Portail.",
      "unsupported": "Atlas ne publie pas encore les versions des skills via son API.",
      "not_configured": "Configurez et activez la connexion Atlas pour consulter ses skills.",
      "unauthorized": "Atlas n’a pas autorisé cette consultation. Vérifiez la connexion API.",
      "unavailable": "Impossible de consulter Atlas. Vous pouvez réessayer.",
      "invalid_response": "L’inventaire retourné par Atlas n’est pas valide. Les versions non confirmées ne sont pas affichées.",
      "states": {
        "current": "À jour",
        "update_available": "Mise à jour disponible",
        "development": "En développement",
        "inactive": "Inactive",
        "unknown": "Non confirmé"
      },
      "channels": {
        "stable": "Stable",
        "development": "Développement",
        "unknown": "Non confirmé"
      },
      "runtimeTitle": "API Atlas",
      "apiVersion": "Version API déclarée",
      "apiRelease": "Release",
      "recognitionSchema": "Contrat de reconnaissance",
      "documentContract": "Contrat documentaire",
      "runtimeMismatch": "L’empreinte du code chargé diffère de la release déclarée par Atlas. Son exécution ne peut pas être confirmée.",
      "runtimeUnavailable": "Atlas n’a pas confirmé la version de son API lors de cette vérification.",
      "readerTitle": "Dernier lecteur documentaire observé",
      "readerLean": "Lean : une preuve explicite figure dans la dernière lecture documentaire enregistrée.",
      "readerNotObserved": "Aucune preuve vérifiable ne permet d’identifier le lecteur documentaire.",
      "readerVersion": "Version du lecteur",
      "readerVersionUnknown": "Version non confirmée lors de cette vérification",
      "readerObservedAt": "Résultat de lecture observé : {{date}} (heure d’Espagne)",
      "readerObservationHint": "Cette preuve appartient à un résultat enregistré du Portail. Elle ne confirme pas la configuration actuelle du service et ne remplace pas une version publiée par Atlas.",
      "skillsTitle": "Inventaire des skills",
      "skillsHint": "Versions communiquées par Atlas. Une skill photographique n’identifie pas à elle seule le lecteur PDF ou Excel.",
      "versionConflictLabel": "Vérifier l’inventaire",
      "versionConflictHint": "Atlas communique une dernière version antérieure à la version installée ou active. Les valeurs sont conservées, sans confirmer que la skill est à jour."
    },
    "approve": "Approuver",
    "approveConfirmText": "L’entreprise et l’utilisateur seront créés, et l’accès sera immédiat.",
    "approveConfirmTitle": "Approuver cette inscription ?",
    "approved": "Inscription approuvée",
    "assistantOff": "Désactivé",
    "assistantOn": "Actif",
    "assistantReachable": "Service joignable",
    "assistantSection": "Assistant Atlas",
    "assistantToggle": "Afficher l’assistant aux clients",
    "assistantToggleHint": "En le désactivant, il disparaît du menu et le portail cesse d’accepter les questions. Le service continue de tourner : vous pouvez le réactiver quand vous voulez.",
    "assistantUnreachable": "Service injoignable",
    "assistantAnalyticsTitle": "Ce que les clients demandent à Atlas",
    "assistantAnalyticsSubtitle": "Historique cumulé des requêtes pour détecter les besoins et les produits nécessitant davantage d’aide.",
    "assistantAnalyticsAnonymous": "Données agrégées",
    "assistantAnalyticsQuestions": "Questions posées",
    "assistantAnalyticsChats": "Discussions ouvertes",
    "assistantAnalyticsCoverage": "Demandes liées à des produits",
    "assistantAnalyticsTopProducts": "Produits suscitant le plus de questions",
    "assistantAnalyticsTopProductsHint": "Produits identifiés et validés par Atlas dans ses réponses.",
    "assistantAnalyticsQuestionTypes": "Ce que les utilisateurs demandent",
    "assistantAnalyticsQuestionTypesHint": "Motif principal de chaque demande, regroupé par intention.",
    "assistantAnalyticsTopics": "Sujets les plus consultés",
    "assistantAnalyticsTopicsHint": "Domaines techniques qui apparaissent le plus souvent.",
    "assistantAnalyticsTimeline": "Activité quotidienne",
    "assistantAnalyticsTimelineHint": "Évolution des demandes et discussions pendant la période conservée.",
    "assistantAnalyticsTimelineValue": "{{questions}} demandes · {{sessions}} discussions",
    "assistantAnalyticsEmpty": "Il n’y a pas encore assez de demandes pour afficher ce classement.",
    "assistantAnalyticsPrivacyTitle": "Confidentialité dès la conception",
    "assistantAnalyticsPrivacyText": "Cette vue ne reçoit ni noms, ni adresses e-mail, ni textes complets des conversations. Elle affiche uniquement des totaux agrégés.",
    "auditAction": "Action",
    "auditEmpty": "Aucune activité enregistrée",
    "auditEmptyText": "Tout ce qui se passe sur le portail est consigné ici.",
    "auditEntity": "Élément",
    "auditWho": "Qui",
    "budgetActions": "Actions du devis",
    "budgetCompany": "Entreprise",
    "budgetValidUntil": "Valable jusqu’au",
    "budgetsEmpty": "Aucun devis ne correspond à votre recherche.",
    "budgetsHint": "Tous les devis créés depuis le Portail, avec leur auteur et leur date de création.",
    "budgetsSearch": "Rechercher par référence ou projet",
    "budgetsTitle": "Devis du Portail",
    "colApplicant": "Demandeur",
    "colCompany": "Entreprise",
    "colOrigin": "Origine",
    "colWaiting": "Demandée le",
    "extend": "Prolonger la validité",
    "extendDone": "Validité prolongée.",
    "extendField": "Nouvelle date de validité",
    "extendText": "Choisissez jusqu’à quand « {{ref}} » reste valable. Le client sera averti.",
    "extendTitle": "Prolonger la validité",
    "hermesApiKey": "Clé d’API",
    "hermesApiKeyHint": "Envoyée à Atlas pour identifier le portail.",
    "hermesAutoSubmit": "Confier le travail à l’envoi de la demande",
    "hermesAutoSubmitHint": "Désactivé, Adaltra confie le travail à la main.",
    "hermesAutoSubmitNeedsSecret": "Nécessite le secret de signature : sans lui, la réponse d’Atlas ne peut pas être vérifiée.",
    "hermesBaseUrl": "Adresse de l’API",
    "hermesCallbackSecret": "Secret de signature",
    "hermesCallbackSecretHint": "Atlas signe ses réponses avec. Ce n’est pas la clé d’API.",
    "hermesCallbackUrl": "Atlas doit répondre à",
    "hermesClear": "Effacer",
    "hermesEnabled": "Intégration active",
    "hermesEnabledHint": "Désactivée, le portail n’envoie rien et n’accepte aucune réponse.",
    "hermesHint": "Atlas rédige les devis à partir des demandes envoyées et les crée dans Ada-quote, où un commercial les vérifie.",
    "hermesSaved": "Connexion enregistrée.",
    "hermesSecretPlaceholder": "Saisir pour le remplacer",
    "hermesSecretSet": "Enregistré",
    "hermesSecretUnset": "Non configuré",
    "hermesTest": "Tester la connexion",
    "hermesTestFail": {
      "missingBaseUrl": "L’adresse de l’API manque.",
      "missingApiKey": "La clé d’API manque.",
      "unauthorized": "Atlas refuse la clé.",
      "badStatus": "Atlas répond, mais avec une erreur ({{status}}).",
      "timeout": "Atlas n’a pas répondu à temps.",
      "unreachable": "Impossible de se connecter à cette adresse."
    },
    "hermesTestOk": "Atlas répond correctement.",
    "hermesTesting": "Test en cours…",
    "hermesTimeout": "Délai maximal (ms)",
    "hermesTitle": "Agent Atlas",
    "onlyStaff": "Cet espace est réservé au personnel d’Adaltra.",
    "registrationsEmpty": "Aucune inscription en attente",
    "registrationsEmptyText": "Les demandes d’accès des nouveaux clients apparaîtront ici.",
    "reject": "Refuser",
    "rejectConfirmText": "La demande sera marquée comme refusée et aucun compte ne sera créé.",
    "rejectConfirmTitle": "Refuser cette inscription ?",
    "rejected": "Inscription refusée",
    "remind": "Renvoyer l’avis",
    "remindDone": "Avis renvoyé au client.",
    "sectionNav": "Sections d’administration",
    "settingsSaved": "Réglages enregistrés",
    "notificationsSaved": "Configuration des notifications enregistrée.",
    "notificationChannelsTitle": "Canaux des avis généraux",
    "notificationChannelsHint": "Choisissez comment les clients reçoivent les avis du portail.",
    "pushBroadcastTitle": "Envoyer une notification push",
    "pushBroadcastHint": "Rédigez un court avis pour toutes les personnes ayant activé les notifications sur un appareil.",
    "pushBroadcastModalHint": "Elle sera envoyée à {{count}} appareils abonnés. Vérifiez le contenu avant de confirmer.",
    "composePush": "Rédiger la notification",
    "registeredUsers": "Utilisateurs inscrits",
    "pushSubscribedUsers": "Push activé",
    "pushConfigureBeforeSend": "Configurez et activez d’abord les clés push pour envoyer un avis.",
    "pushMessageTitle": "Titre de la notification",
    "pushMessageBody": "Message",
    "sendPushNow": "Envoyer la notification",
    "pushBroadcastSent": "Notification envoyée à {{count}} appareils.",
    "emailChannelTitle": "Avis généraux par e-mail",
    "emailChannelHint": "Contrôlez séparément l’envoi par e-mail des avis automatiques du portail.",
    "channelPortal": "Portail et cloche",
    "channelPortalHint": "Enregistre l’avis dans le centre de notifications.",
    "channelEmail": "E-mail",
    "channelEmailHint": "Envoie une copie via le serveur SMTP.",
    "channelPush": "Notification push",
    "channelPushHint": "Affiche l’avis sur l’appareil même lorsque Atlas est fermé.",
    "smtpTitle": "Serveur de courrier SMTP",
    "smtpHint": "Configurez le serveur des avis et e-mails transactionnels du portail.",
    "smtpUrl": "URL SMTP (facultatif)",
    "smtpUrlHint": "Si elle est indiquée, elle remplace le serveur et le port.",
    "smtpUrlConfigured": "Une URL SMTP protégée est configurée. Elle sera conservée tant qu’aucun autre serveur n’est indiqué.",
    "smtpHost": "Serveur",
    "smtpPort": "Port",
    "smtpSecure": "Utiliser une connexion sécurisée directe (TLS)",
    "smtpUser": "Utilisateur",
    "smtpPassword": "Mot de passe",
    "smtpPasswordHint": "Laissez vide pour conserver le mot de passe enregistré.",
    "smtpFrom": "Expéditeur",
    "smtpReplyTo": "Répondre à (facultatif)",
    "smtpEnabled": "Activer l’envoi d’e-mails",
    "smtpTestSent": "E-mail de test envoyé à {{email}}.",
    "pushTitle": "Notifications push",
    "pushHint": "Configurez les clés VAPID stables utilisées par Atlas auprès des navigateurs.",
    "pushPublicKey": "Clé publique VAPID",
    "pushPrivateKey": "Clé privée VAPID",
    "pushPrivateKeyHint": "Elle ne sera plus affichée. Laissez vide pour la conserver.",
    "pushSubject": "Contact du service",
    "pushSubjectHint": "Généralement une adresse comme mailto:support@example.com.",
    "pushEnabled": "Activer les notifications push",
    "generateVapid": "Générer les clés",
    "sendTest": "Envoyer un test",
    "pushTestSent": "Notification de test envoyée à cet appareil.",
    "pushTestNoSubscription": "La configuration fonctionne, mais cet utilisateur n’a encore aucun appareil abonné.",
    "configurationFromEnvironment": "Cette configuration provient actuellement de l’environnement du serveur. En l’enregistrant ici, elle sera gérée dans Administration.",
    "statActiveUsers": "Utilisateurs actifs",
    "statOpenTickets": "Tickets ouverts",
    "statPendingRegistrations": "Inscriptions en attente",
    "subtitle": "Inscriptions clients, devis, support et réglages du portail.",
    "tabAudit": "Audit",
    "tabAssistantAnalytics": "Analytique Atlas",
    "tabBudgets": "Devis",
    "tabRegistrations": "Inscriptions",
    "tabSettings": "Réglages",
    "tabNotifications": "Notifications",
    "tabEmail": "E-mail",
    "tabTickets": "Assistance",
    "tabUsers": "Utilisateurs",
    "tabReleases": "Nouveautés",
    "releasesTitle": "Nouveautés de la plateforme",
    "releasesDescription": "Modifications publiées pour les Commerciaux et Gestionnaires.",
    "releaseNew": "Nouvelle version",
    "releasesEmpty": "Aucune version pour le moment",
    "releasesEmptyText": "Les nouveautés publiées apparaîtront ici.",
    "releaseStatus": {
      "draft": "Brouillon",
      "published": "Publiée"
    },
    "releaseLinkedCount": "{{count}} demandes liées",
    "releaseIncludesYours": "Inclut l’une de vos demandes",
    "releaseEdit": "Modifier la version",
    "releaseVersion": "Version",
    "releaseTitle": "Titre",
    "releaseSummary": "Résumé",
    "releaseChanges": "Modifications",
    "releaseChangesHelp": "Saisissez une modification par ligne.",
    "releaseLinkedRequests": "Demandes liées",
    "releaseLinkedRequestsHelp": "La publication terminera toutes les demandes liées.",
    "releaseSaved": "Version enregistrée.",
    "platformRequestTitle": "Proposer une amélioration",
    "platformRequestAction": "Proposer une amélioration ou modification",
    "platformRequestDescription": "Indiquez ce qui devrait être ajouté ou amélioré sur la plateforme.",
    "platformRequestSubject": "Titre de la demande",
    "platformRequestDetails": "Description",
    "platformRequestSend": "Envoyer la demande",
    "platformRequestSent": "Demande envoyée.",
    "platformRequestsAll": "Demandes des employés",
    "platformRequestsMine": "Mes demandes",
    "platformRequestsAllText": "Examinez, planifiez et liez les propositions à une version.",
    "platformRequestsMineText": "Suivez leur état et la version dans laquelle elles sont incluses.",
    "platformRequestsEmpty": "Aucune demande",
    "platformRequestsEmptyText": "Les nouvelles propositions apparaîtront ici.",
    "platformRequestStatus": {
      "new": "Nouvelle",
      "under_review": "En cours d’examen",
      "planned": "Planifiée",
      "declined": "Refusée",
      "completed": "Terminée"
    },
    "platformRequestAdminNote": "Note de l’administrateur",
    "platformRequestIncluded": "Incluse dans la v{{version}}",
    "platformRequestReview": "Examiner la demande",
    "platformRequestSaved": "Demande mise à jour.",
    "usersTitle": "Gestion des utilisateurs",
    "usersHint": "Gérez l’accès au portail et le lien commercial de chaque compte.",
    "usersCount": "{{count}} utilisateurs",
    "searchUsers": "Rechercher des utilisateurs",
    "user": "Utilisateur",
    "userRole": "Rôle",
    "userRole_client": "Client",
    "userRole_commercial": "Commercial",
    "userRole_manager": "Gestionnaire",
    "userRole_admin": "Administrateur",
    "rolesAdminOnly": "Seul un administrateur peut modifier les rôles.",
    "emailBroadcastTitle": "Envoyer un e-mail général",
    "emailBroadcastHint": "Envoyez le même message en copie cachée à tous les utilisateurs actifs du rôle choisi.",
    "emailAudienceRole": "Destinataires",
    "emailSubject": "Objet",
    "emailBody": "Message",
    "addAttachments": "Ajouter des pièces jointes",
    "noAttachments": "Aucune pièce jointe · 5 fichiers de 10 Mo maximum",
    "sendEmailNow": "Envoyer l’e-mail",
    "sendingEmail": "Envoi…",
    "emailBroadcastSent": "E-mail envoyé à {{count}} destinataires avec {{attachments}} pièces jointes.",
    "userStatus_pending": "En attente",
    "userStatus_active": "Actif",
    "userStatus_blocked": "Bloqué",
    "customerCode": "Code client",
    "generatedBudgets": "Demandes et devis",
    "viewUserRequests": "Voir toutes les demandes de cet utilisateur",
    "userRequestsTitle": "Demandes de {{name}}",
    "userRequestsHint": "Inclut les brouillons, les lectures, les révisions et les devis générés. Vous pouvez reprendre, réanalyser et gérer les demandes de l’utilisateur.",
    "userRequestsEmpty": "Cet utilisateur n’a encore créé aucune demande.",
    "userRequestItems": "{{count}} articles",
    "userRequestCreated": "Créée",
    "userRequestFiles": "Fichiers",
    "userRequestBudget": "Devis",
    "userRequestBudgetPending": "Pas encore généré",
    "userRequestMaterials": "Liste du matériel",
    "userRequestMaterialsPending": "La liste du matériel n’est pas encore disponible à cette étape.",
    "assistantAnalyticsRecentQuestions": "Questions récentes",
    "assistantAnalyticsRecentQuestionsHint": "Questions envoyées à l’assistant avec le compte qui les a posées.",
    "assistantAnalyticsUnknownUser": "Utilisateur indisponible",
    "lastAccess": "Dernier accès",
    "neverAccessed": "Jamais",
    "editUser": "Modifier l’utilisateur",
    "adaQuoteCustomerCodeAdminHint": "Code AdaQuote de cette entreprise ou agence. Il s’applique à ses comptes Client ; les autres agences peuvent le partager sans être modifiées.",
    "editCustomerCode": "Modifier le code client",
    "editCustomerCodeFor": "Modifier le code client de {{name}}",
    "staffCustomerCodeHint": "L’administrateur peut attribuer un code personnel à ce compte. Sans code, il utilise 0.",
    "staffPersonalCustomerCodeHint": "Code personnel de cet utilisateur pour envoyer et consulter les devis. L’entreprise et les autres utilisateurs ne sont pas modifiés. Laissez vide pour utiliser 0.",
    "personalCustomerCodeHint": "Code personnel de cet administrateur pour envoyer et consulter les devis. Les autres utilisateurs ne sont pas affectés. Laissez vide pour utiliser 0.",
    "userSaved": "Utilisateur mis à jour.",
    "ticketClosed": "Fermé",
    "ticketInProgress": "En cours",
    "ticketOpen": "Ouvert",
    "ticketsEmpty": "Aucun ticket",
    "ticketsEmptyText": "Les demandes d’assistance des clients apparaîtront ici.",
    "title": "Administration",
    "withdraw": "Retirer l’offre",
    "withdrawDone": "Devis retiré.",
    "withdrawText": "« {{ref}} » passera en expiré et le client ne pourra plus l’accepter. Il en sera averti.",
    "withdrawTitle": "Retirer ce devis ?",
    "adaQuoteTitle": "Ada-quote",
    "adaQuoteHint": "Connexion directe facultative pour synchroniser les devis. Le stock et les PDF disposent également de leur consultation via Atlas.",
    "adaQuoteBaseUrl": "Adresse de l’API",
    "adaQuoteApiKey": "Clé d’API",
    "adaQuoteApiKeyHint": "Envoyée à Ada-quote pour identifier le portail.",
    "adaQuoteEnabled": "Connexion active",
    "adaQuoteEnabledHint": "Désactivée, la synchronisation directe avec Ada-quote est ignorée. La connexion Atlas reste inchangée.",
    "adaQuoteSaved": "Connexion enregistrée.",
    "adaQuoteTestOk": "Ada-quote répond correctement.",
    "adaQuoteTestNoHealth": "Ada-quote répond et accepte la clé, bien qu’il n’ait pas de page d’état.",
    "adaQuoteTestFail": {
      "missingBaseUrl": "L’adresse de l’API manque.",
      "missingApiKey": "La clé d’API manque.",
      "unauthorized": "Ada-quote refuse la clé.",
      "badStatus": "Ada-quote répond, mais avec une erreur ({{status}}).",
      "timeout": "Ada-quote n’a pas répondu à temps.",
      "unreachable": "Impossible de se connecter à l’adresse d’Ada-quote."
    },
    "adaQuoteScope": "Chaque client ne voit que ses devis : le portail utilise le code client AdaQuote de l’entreprise de la session, jamais un code envoyé par le navigateur.",
    "connectionChecking": "Vérification…",
    "connectionKeyNotVerified": "Il répond, mais nous n’avons pas pu vérifier la clé.",
    "modules": {
      "title": "Modules",
      "checking": "Vérification de chaque module…",
      "summary": "{{active}} sur {{total}} actifs",
      "withIssues": "{{count}} avec incidents",
      "refresh": "Vérifier maintenant",
      "version": "Version {{version}}",
      "versionUnknown": "Version non disponible",
      "configure": "Configurer",
      "tools": "Outils",
      "serverSwitch": "Activé sur le serveur",
      "state": {
        "on": "Actif",
        "off": "Désactivé",
        "error": "Erreur",
        "warning": "Pas à jour",
        "checking": "Vérification…"
      },
      "atlas": {
        "title": "Atlas · API de lecture",
        "text": "Lit les documents des demandes, identifie les produits et prépare les devis."
      },
      "adaQuote": {
        "title": "Ada-quote",
        "text": "Prix, remises, stock et devis dans l’ERP."
      },
      "customers": {
        "title": "Référentiel clients",
        "text": "Clients et adresses de livraison d’Ada, pour attribuer un client et passer commande.",
        "detail": "{{count}} clients · version {{version}} · vérifié {{date}}",
        "stale": "Pas mis à jour depuis {{date}}",
        "unavailable": "Atlas ne répond pas"
      },
      "catalog": {
        "title": "Catalogue produits",
        "text": "Copie du Master produits publié par Atlas, pour rechercher et valider les références.",
        "detail": "{{count}} produits · version {{version}} · {{date}}"
      },
      "assistant": {
        "text": "Chat d’aide Atlas pour le personnel et les clients."
      }
    },
    "notifConfig": {
      "pushTitle": "Configuration des avis",
      "pushHint": "Web Push et les canaux par lesquels arrivent les avis du portail.",
      "emailTitle": "Configuration de l’e-mail",
      "emailHint": "Serveur de messagerie (SMTP) et avis par e-mail.",
      "sender": "Expéditeur",
      "notConfigured": "Non configuré"
    },
    "connection": {
      "connected": "Connecté",
      "error": "Erreur",
      "disconnected": "Déconnecté"
    },
    "direccion": {
      "interna": "Cette adresse n’existe qu’à l’intérieur du réseau local. Le portail l’atteint d’ici, mais plus une fois déployé ailleurs. Il faut alors un tunnel ou une adresse publique.",
      "sinCifrar": "Adresse non chiffrée (http). La clé d’API voyage dans un en-tête : hors de votre réseau, utilisez https.",
      "malformada": "Cette adresse ne semble pas valide. Elle doit commencer par https:// ou http://."
    },
    "catalogSync": "Copier le catalogue",
    "catalogSyncing": "Copie en cours…",
    "catalogSynced": "Catalogue copié : {{count}} articles ({{deactivated}} retirés).",
    "catalogAlreadyCurrent": "La copie est déjà à jour : {{count}} articles.",
    "approvedEmailUnavailable": "Compte approuvé. Le courriel de notification n’a pas pu être envoyé au client.",
    "requestSendToAtlas": "Envoyer à Atlas",
    "requestSendConfirm": "Vous enverrez {{ref}}, avec {{count}} lignes, à Atlas pour créer le devis AdaQuote de {{name}}. Les coordonnées et le code client du propriétaire seront utilisés.",
    "requestReviewWithAtlas": "Vérifier avec Atlas",
    "requestDiscardSuggestion": "Ne pas ajouter",
    "requestRecovered": "Liste récupérée depuis {{ref}}. Terminez la vérification avant l’envoi.",
    "requestAlreadySent": "Ce dossier a déjà été envoyé à Atlas ou possède un devis associé.",
    "requestNeedsReview": "La liste doit terminer sa vérification avant l’envoi.",
    "requestContinue": "Continuer la demande",
    "requestOpen": "Ouvrir la demande",
    "requestReanalyze": "Analyser à nouveau",
    "requestDelete": "Supprimer la demande",
    "requestCancel": "Annuler la demande",
    "requestRestore": "Rétablir la demande",
    "requestBackToUsers": "Retour aux utilisateurs",
    "requestActingFor": "Gestion de la demande de {{name}} · {{company}}",
    "requestExistingOnly": "Continuez cette demande ou revenez à Administration pour en choisir une autre.",
    "requestActionTitle_reanalyze": "Analyser à nouveau les documents",
    "requestActionTitle_delete": "Supprimer la demande",
    "requestActionTitle_cancel": "Annuler la demande",
    "requestActionConfirm_reanalyze": "Analyser à nouveau les documents de {{ref}}, de {{name}} ? La liste sera réexaminée et les résultats devront être confirmés avant l’envoi.",
    "requestActionConfirm_delete": "Supprimer définitivement {{ref}}, de {{name}}, et ses fichiers ? Cette action est irréversible.",
    "requestActionConfirm_cancel": "Annuler {{ref}}, de {{name}} ? Vous pourrez ensuite la rétablir ou la supprimer définitivement depuis Administration.",
    "requestBudgetReadOnly": "Consultation administrative du devis. L’acceptation et le refus restent à la charge du client.",
    "userRole_orders": "Commandes",
    "deleteUserDescription": "L’accès sera retiré et l’utilisateur disparaîtra de cette liste. Ses demandes, devis et historique d’audit seront conservés.",
    "passwordChangePending": "Changement de mot de passe requis",
    "forcePasswordResetDescription": "Un e-mail contiendra un lien valable une heure pour saisir et confirmer un nouveau mot de passe. Après l’envoi, ses sessions seront fermées et le changement sera requis pour se reconnecter.",
    "ownPasswordAction": "Changez votre mot de passe depuis votre profil",
    "deletingUser": "Suppression…",
    "sendingPasswordReset": "Envoi…",
    "userDeleted": "Utilisateur supprimé. Ses demandes et devis sont conservés.",
    "deleteUser": "Supprimer l’utilisateur",
    "sendPasswordReset": "Envoyer l’e-mail",
    "cannotDeleteSelf": "Vous ne pouvez pas supprimer votre propre compte",
    "forcePasswordResetFor": "Imposer un nouveau mot de passe à {{name}}",
    "passwordResetSent": "E-mail envoyé. Le changement de mot de passe est requis pour se reconnecter.",
    "forcePasswordReset": "Imposer un nouveau mot de passe",
    "deleteUserFor": "Supprimer {{name}}",
    "budgetCreatedBy": "Créé par",
    "budgetCreatedAt": "Date de création",
    "budgetsPerPage": "Devis par page",
    "budgetPageRange": "{{from}}–{{to}} sur {{count}}"
  },
  "assistant": {
    "title": "Assistant Atlas",
    "placeholder": "Écrivez votre question…",
    "send": "Envoyer",
    "thinking": "Atlas est en train d’écrire…",
    "newConversation": "Nouvelle conversation",
    "resetConfirmTitle": "Démarrer une nouvelle conversation ?",
    "resetConfirmText": "Un chat vierge s’ouvrira. Chaque conversation et son historique complet sont supprimés 24 heures après leur création, même si vous continuez à écrire.",
    "emptyTitle": "Comment puis-je vous aider ?",
    "emptyText": "Interrogez-moi sur les produits Ekselans : caractéristiques, fiches techniques, manuels et disponibilité.",
    "suggestion1": "Quels points d’accès WiFi 6 proposez-vous ?",
    "suggestion2": "Donne-moi la fiche technique de l’AX 3000",
    "suggestion3": "Comment demander une extension de garantie ?",
    "you": "Vous",
    "assistantName": "Atlas",
    "disclaimer": "Atlas peut se tromper. Vérifiez toujours les références avant de confirmer une commande.",
    "unavailableTitle": "L’assistant n’est pas disponible",
    "unavailableText": "Nous n’avons pas pu joindre Atlas. Réessayez dans quelques minutes.",
    "drawingDiagram": "Tracé du schéma…",
    "downloadDiagram": "Télécharger le schéma en PNG",
    "diagramFileName": "schema-atlas",
    "enlargeImage": "Agrandir l’image",
    "enlargeDiagram": "Agrandir le schéma",
    "stop": "Arrêter la réponse",
    "stopped": "Réponse arrêtée",
    "copyAnswer": "Copier la réponse",
    "jumpToLatest": "Aller au dernier message",
    "threadLabel": "Conversation avec Atlas",
    "charsLeft_one": "Il reste {{count}} caractère",
    "charsLeft_other": "Il reste {{count}} caractères",
    "charLimit": "La limite de {{max}} caractères est atteinte.",
    "resetConfirmAction": "Recommencer",
    "sendFailed": "Le message n’a pas pu être envoyé.",
    "composerHint": "Entrée pour envoyer · Maj+Entrée pour un saut de ligne",
    "conversations": "Conversations",
    "showConversations": "Afficher les conversations",
    "hideConversations": "Masquer les conversations",
    "untitled": "Nouvelle conversation",
    "newChat": "Nouvelle conversation",
    "noConversations": "Vous n’avez pas encore parlé à Atlas",
    "renameTitle": "Renommer la conversation",
    "renameLabel": "Nom",
    "removeTitle": "Supprimer cette conversation ?",
    "removeText": "La conversation et sa transcription seront définitivement supprimées. Cette action est irréversible.",
    "remove": "Supprimer",
    "conversationOptions": "Options de la conversation",
    "olderThanWeek": "Plus anciennes",
    "thisWeek": "Cette semaine",
    "reasoning": "Atlas réfléchit…",
    "reasoningSteps": {
      "searching": "Recherche d’informations",
      "consulting": "Consultation de la documentation",
      "comparing": "Comparaison des options",
      "verifying": "Vérification des données",
      "identifying": "Identification du produit",
      "clarifying": "Clarification des besoins",
      "preparing": "Préparation de la réponse",
      "reviewing": "Analyse de la demande",
      "working": "Traitement de la demande"
    }
  },
  "assistantWidget": {
    "needHelp": "Besoin d’aide ?",
    "productQuestion": "Une question sur un produit ?",
    "open": "Parler avec la mascotte Atlas",
    "title": "Atlas",
    "status": "Votre assistant produits",
    "greeting": "Bonjour ! Je suis Atlas. Interrogez-moi sur un produit, une équivalence ou votre prochain devis.",
    "expand": "Ouvrir l’Assistant complet",
    "placeholder": "Écrire à Atlas…",
    "send": "Envoyer le message",
    "thinking": "Atlas réfléchit…"
  },
  "auth": {
    "signInTitle": "Accédez à votre portail",
    "signInSubtitle": "Consultez vos demandes et vos devis au même endroit.",
    "email": "Adresse e-mail",
    "password": "Mot de passe",
    "showPassword": "Afficher le mot de passe",
    "hidePassword": "Masquer le mot de passe",
    "rememberMe": "Se souvenir de moi",
    "forgotPassword": "Mot de passe oublié ?",
    "signIn": "Se connecter",
    "signingIn": "Connexion…",
    "secureAccess": "Accès sécurisé pour les clients Adaltra",
    "noAccount": "Vous n'avez pas encore de compte ?",
    "createAccount": "Créer un compte",
    "haveAccount": "Vous avez déjà un compte ?",
    "backToSignIn": "Revenir à la connexion",
    "orContinueWith": "ou continuez avec",
    "continueWithGoogle": "Continuer avec Google",
    "continueWithMicrosoft": "Continuer avec Outlook",
    "googleShort": "Google",
    "microsoftShort": "Outlook",
    "providerNotConfigured": "Cette méthode de connexion n'est pas encore configurée. Ajoutez les identifiants sur le serveur pour l'activer.",
    "heroTitle": "De votre liste de matériel au devis, en toute simplicité.",
    "heroSubtitle": "Photographiez, vérifiez et confirmez. Vous gardez la main à chaque étape.",
    "heroTitleRegister": "Demandez vos devis plus simplement.",
    "heroSubtitleRegister": "Créez votre accès au portail client et centralisez toutes les demandes de votre entreprise.",
    "trustDocuments": "Vos documents, protégés",
    "trustReview": "Vérification humaine avant l'envoi",
    "trustSecureSignUp": "Inscription sécurisée et protégée",
    "trustTracking": "Un suivi dès le premier jour",
    "registerTitle": "Créez votre accès",
    "registerSubtitle": "Renseignez les informations principales de votre entreprise pour commencer.",
    "fullName": "Nom complet",
    "phone": "Téléphone",
    "companyName": "Entreprise",
    "taxId": "Numéro de TVA",
    "createAccountAction": "Créer le compte",
    "registeredTitle": "Nous avons vos informations",
    "registrationReceived": "L'équipe Adaltra vérifiera les données de l'entreprise et enverra vos accès à l'adresse indiquée.",
    "forgotTitle": "Récupérez votre mot de passe",
    "forgotSubtitle": "Saisissez votre e-mail et nous vous enverrons un lien pour en créer un nouveau.",
    "sendLink": "Envoyer le lien",
    "resetEmailSent": "Si cette adresse correspond à un compte, vous recevrez un lien pour réinitialiser votre mot de passe.",
    "resetTitle": "Créez un nouveau mot de passe",
    "newPassword": "Nouveau mot de passe",
    "repeatPassword": "Confirmez le mot de passe",
    "passwordUpdated": "Mot de passe mis à jour. Vous pouvez vous connecter.",
    "passwordHint": "Au moins 10 caractères, avec des lettres et des chiffres.",
    "currentPassword": "Mot de passe actuel",
    "changePassword": "Changer de mot de passe",
    "setPassword": "Définir un mot de passe",
    "heroAccent": "toute simplicité.",
    "heroAccentRegister": "plus simplement.",
    "trustDevice": "Appareil de confiance",
    "trustDeviceHint": "Ne pas demander de code sur ce navigateur pendant 30 jours."
  },
  "authProvider": {
    "google": "Inscription avec Google",
    "microsoft": "Inscription avec Outlook",
    "password": "Inscription par formulaire"
  },
  "brand": {
    "name": "Atlas",
    "portal": "Portail client",
    "poweredBy": "Propulsé par",
    "version": "Version {{version}}",
    "company": "Adaltra"
  },
  "budget": {
    "period": "Date d’émission",
    "dateFrom": "Du",
    "dateTo": "Au",
    "invalidDates": "La date de fin doit être égale ou postérieure au début.",
    "paginationSummary": "{{from}}–{{to}} sur {{total}} devis",
    "periods": {
      "all": "Toutes les dates",
      "today": "Aujourd’hui",
      "week": "7 derniers jours",
      "month": "30 derniers jours",
      "quarter": "90 derniers jours",
      "year": "Cette année",
      "custom": "Période personnalisée"
    },
    "listTitle": "Devis",
    "listSubtitle": "Consultez et téléchargez vos commandes approuvées.",
    "refresh": "Actualiser",
    "refreshing": "Actualisation…",
    "searchPlaceholder": "Rechercher par référence ou projet",
    "emptyTitle": "Aucun devis pour le moment",
    "emptyText": "Les devis apparaîtront ici une fois la commande acceptée.",
    "validUntil": "Valable jusqu'au",
    "issuedOn": "Émis le",
    "detailTitle": "Détail du devis",
    "linkedRequest": "Demande liée",
    "downloadPdf": "Télécharger le PDF",
    "approve": "Approuver le devis",
    "reject": "Refuser",
    "approveDialogTitle": "Approuver le devis ?",
    "approveDialogText": "Une fois approuvé, Adaltra lancera la préparation de la commande.",
    "rejectDialogTitle": "Refuser le devis ?",
    "rejectDialogText": "Indiquez-nous le motif afin que nous puissions vous proposer mieux.",
    "rejectReason": "Motif du refus",
    "approvedMessage": "Devis approuvé",
    "rejectedMessage": "Devis refusé",
    "pendingEyebrow": "EN ATTENTE D'APPROBATION",
    "pendingTitle": "Vérifiez et approuvez votre devis",
    "pendingText": "Contrôlez le montant et les conditions avant de confirmer la proposition.",
    "draftEyebrow": "Pas encore définitif",
    "draftTitle": "Votre devis est en cours de revue",
    "draftText": "Il est prêt et un commercial d’Adaltra le vérifie. Vous pouvez le consulter en attendant, mais les montants peuvent encore changer : vous pourrez l’accepter ou le refuser lorsqu’il vous l’enverra.",
    "approvedEyebrow": "DEVIS APPROUVÉ",
    "approvedTitle": "Devis approuvé",
    "approvedText": "La proposition a été approuvée et vous pouvez télécharger le document final.",
    "orderedEyebrow": "TRANSFORMÉ EN COMMANDE",
    "orderedTitle": "Commande {{order}} créée",
    "orderedText": "Le devis a été gagné et la commande est déjà traitée dans MTR.",
    "sentEyebrow": "DEVIS ENVOYÉ",
    "sentTitle": "Votre devis est prêt",
    "sentText": "Consultez le résumé et téléchargez le document complet en PDF.",
    "expiredEyebrow": "DEVIS EXPIRÉ",
    "expiredTitle": "Ce devis a expiré",
    "expiredText": "Demandez une mise à jour pour revoir les prix et la disponibilité.",
    "rejectedEyebrow": "DEVIS REFUSÉ",
    "rejectedTitle": "Vous avez refusé ce devis",
    "rejectedText": "Vous pouvez demander une nouvelle proposition quand vous le souhaitez.",
    "commercialRejectedEyebrow": "DEVIS NON APPROUVÉ",
    "commercialRejectedTitle": "Il n’a pas passé la revue commerciale",
    "commercialRejectedText": "Vous pouvez demander une nouvelle proposition.",
    "unitPrice": "Prix unitaire",
    "pricePending": "Prix sur demande",
    "partialTotal_one": "Le total est partiel : le prix de 1 produit reste à définir.",
    "partialTotal_other": "Le total est partiel : les prix de {{count}} produits restent à définir.",
    "discount": "Remise",
    "lineTotal": "Montant",
    "requestChanges": "Demander des modifications",
    "requestChangesDialogTitle": "Qu’y a-t-il à corriger ?",
    "requestChangesDialogText": "Le devis retourne chez Adaltra avec votre note et reste valide : vous ne le refusez pas. Vous recevrez une proposition corrigée.",
    "requestChangesLabel": "Ce qu’il faut revoir",
    "requestChangesHint": "Indiquez la ligne, la quantité ou la référence qui ne va pas. Plus c’est précis, plus vite il revient corrigé.",
    "changesSentMessage": "Nous avons transmis votre demande à Adaltra",
    "changesEyebrow": "MODIFICATIONS DEMANDÉES",
    "changesTitle": "Adaltra examine votre demande",
    "changesText": "Vous recevrez une proposition corrigée. Entre-temps, vous pouvez toujours l’accepter ou le refuser en l’état.",
    "changesNoteLabel": "Ce que vous avez demandé de corriger",
    "viewPdf": "Voir le PDF",
    "hidePdf": "Masquer le PDF",
    "openPdfInTab": "Ouvrir dans un onglet",
    "pdfNotReady": "Le PDF n’est pas encore disponible",
    "pdfNotReadyText": "Adaltra le joindra une fois signé. Le détail des lignes ci-dessous est déjà définitif.",
    "pdfFallback": "Votre navigateur ne peut pas afficher le PDF ici. Ouvrez-le dans un onglet ou téléchargez-le.",
    "revision": "Révision {{count}}",
    "expiredOn": "Expiré le {{date}}",
    "expiresToday": "Expire aujourd’hui",
    "expiresIn_one": "Expire dans {{count}} jour",
    "expiresIn_other": "Expire dans {{count}} jours",
    "requestAgain": "En demander un nouveau",
    "decide": "Décider"
  },
  "budgetStatus": {
    "draft": "En revue commerciale",
    "sent": "Envoyé",
    "pending_approval": "En attente d'approbation",
    "approved": "Approuvé",
    "rejected": "Refusé",
    "expired": "Expiré",
    "changes_requested": "Modifications demandées",
    "ordered": "Commande créée"
  },
  "common": {
    "openInNewTab": "Ouvrir dans un nouvel onglet",
    "continue": "Continuer",
    "back": "Retour",
    "cancel": "Annuler",
    "save": "Enregistrer",
    "saveChanges": "Enregistrer les modifications",
    "saved": "Modifications enregistrées",
    "delete": "Supprimer",
    "edit": "Modifier",
    "add": "Ajouter",
    "search": "Rechercher",
    "filter": "Filtrer",
    "all": "Tous",
    "close": "Fermer",
    "confirm": "Confirmer",
    "download": "Télécharger",
    "retry": "Réessayer",
    "loadMore": "Charger plus",
    "loading": "Chargement…",
    "saving": "Enregistrement…",
    "sending": "Envoi…",
    "optional": "Facultatif",
    "required": "Obligatoire",
    "yes": "Oui",
    "no": "Non",
    "of": "sur",
    "page": "Page",
    "quantity": "Quantité",
    "unit": "Unité",
    "description": "Description",
    "code": "Code",
    "reference": "Référence",
    "brandLabel": "Marque",
    "date": "Date",
    "status": "Statut",
    "total": "Total",
    "subtotal": "Sous-total",
    "vat": "TVA",
    "project": "Projet",
    "actions": "Actions",
    "noResults": "Aucun résultat",
    "seeAll": "Tout voir",
    "seeDetail": "Voir le détail",
    "preview": "Aperçu",
    "rotate": "Pivoter",
    "zoom": "Agrandir",
    "empty": "Aucune donnée pour le moment",
    "copy": "Copier",
    "copied": "Copié",
    "dismiss": "Ignorer",
    "rename": "Renommer",
    "today": "Aujourd’hui",
    "yesterday": "Hier",
    "showMore": "Voir plus",
    "showLess": "Voir moins",
    "view": "Voir",
    "catalogName": "catalogue",
    "brand": "Marque"
  },
  "dashboard": {
    "attentionAllDone": "Tout est à jour",
    "attentionAllDoneText": "Rien n’attend de votre part. Créez une demande quand vous en aurez besoin.",
    "attentionNextStep": "Étape suivante",
    "attentionTitle": "Demande votre attention",
    "createFirst": "Créer la première demande",
    "emptyBudgets": "Vos devis apparaîtront ici dès qu'ils seront prêts.",
    "emptyRequests": "Vous n'avez encore créé aucune demande.",
    "greeting": "{{salutation}}, {{name}}",
    "greetings": {
      "morning": "Bonjour",
      "afternoon": "Bon après-midi",
      "night": "Bonsoir"
    },
    "groupDecide": "Prêts pour votre décision",
    "groupDecideText": "Acceptez-les, demandez des modifications ou refusez-les.",
    "groupExpired": "Expirés",
    "groupExpiredText": "Ils ne peuvent plus être acceptés. Demandez-en un nouveau si besoin.",
    "groupReview": "En attente de votre vérification",
    "reviewReadingText": "La lecture du document attend votre confirmation.",
    "reviewProductsText": "Vérifiez la liste et résolvez les produits en attente.",
    "reviewRecommendationsText": "Des recommandations d’Atlas restent à vérifier.",
    "reviewConfirmationText": "La liste est vérifiée. Confirmez et envoyez la demande.",
    "groupReviewText": "Atlas a lu la liste. Vérifiez-la et corrigez ce qu’il faut.",
    "readingErrorText": "Le fichier n’a pas pu être lu. Ouvrez la demande pour relancer l’analyse ou remplacer les fichiers.",
    "groupSubmitted": "Envoyées à Atlas",
    "groupSubmittedText": "Nous préparons le devis.",
    "inProgressText": "Nous nous en occupons. Rien à faire de votre côté.",
    "inProgressViewAll": "Voir les {{count}} demandes en cours",
    "inProgressTitle": "En cours",
    "itemsAndLines": "{{count}} lignes",
    "newRequestCta": "Nouvelle demande de devis",
    "newRequestHint": "Photographiez votre liste de matériel ou importez-la sous forme de fichier.",
    "recentBudgets": "Derniers devis",
    "recentEmpty": "Vos demandes et devis apparaîtront ici au fur et à mesure de leur clôture.",
    "recentRequests": "Dernières demandes",
    "recentTitle": "Votre activité récente",
    "reviewCta": "Vérifier la demande",
    "seeBudgets": "Voir tous les devis",
    "seeRequests": "Voir toutes les demandes",
    "statApprovedBudgets": "Devis approuvés",
    "statApprovedTotal": "Montant approuvé",
    "statDecision": "En attente de ta décision",
    "statReview": "En attente de ta révision",
    "statTotalBudgets": "Total des devis",
    "statOpenRequests": "Demandes en cours",
    "statPendingBudgets": "Devis en attente",
    "subtitle": "Voici l'état de vos demandes et de vos devis.",
    "summaryCount": "{{count}} devis",
    "summaryTitle": "Approuvé à ce jour",
    "toDecide": "Prêt pour votre décision",
    "toReview": "En attente de votre vérification",
    "validatedQuoteText": "Le devis est validé et disponible à consulter ou télécharger avant son acceptation.",
    "viewValidatedQuote": "Voir le devis",
    "attentionEmpty": "Aucune demande ni aucun devis en attente de vérification.",
    "inProgressEmpty": "Vos demandes apparaîtront ici pendant qu’Atlas prépare vos devis.",
    "inProgressOpen": "Voir les demandes en cours"
  },
  "valuation": {
    "informational": "Prix calculés par Ada-quote pour le client et la destination sélectionnés. La date de livraison et le numéro de commande restent enregistrés dans Atlas ; cette consultation ne les applique pas.",
    "basePrice": "Prix de base",
    "unitPriceNet": "Prix net",
    "literalDiscounts": "D1, D2 et D3 sont les remises littérales reçues, dans leur ordre. Leur type et leur base ne sont pas confirmés ; aucun pourcentage ni recalcul n’est appliqué.",
    "queriedAt": "Consulté (heure d’Espagne)",
    "informationalWaiting": "Prix reçus. La confirmation économique reste en attente.",
    "receivedBlocked": "Atlas a enregistré les données de la commande. La valorisation économique attend l’intégration Ada-quote.",
    "noDiscounts": "Aucune remise",
    "title": "Valorisation de la commande",
    "subtitle": "Vérifiez les prix et remises appliqués à ce client avant la confirmation.",
    "request": "Obtenir la valorisation",
    "refresh": "Actualiser la valorisation",
    "pending": "Ada-quote prépare la valorisation…",
    "notRequested": "Demandez la valorisation pour recevoir les prix et conditions de ce client. Cette étape ne confirme aucune commande.",
    "stale": "La valorisation précédente n’est plus à jour. Vérifiez le client, l’adresse et les quantités avant une nouvelle consultation.",
    "expired": "La valorisation a expiré. Actualisez-la pour vérifier les montants actuels.",
    "linesTitle": "Produits valorisés",
    "article": "Article",
    "quantity": "Quantité",
    "unitPrice": "Prix unitaire",
    "discounts": "Remises",
    "netUnitPrice": "Prix remisé",
    "lineTotal": "Montant",
    "sourceNotice": "Les prix, remises et montants sont affichés tels que fournis par Ada-quote.",
    "addedByProvider": "Ajoutée par Ada-quote (absente de la liste)",
    "addedWarning": "Avertissement",
    "addedWillRemove": "Il sera retiré de la commande.",
    "addedNotesHint": "La décision est envoyée à Ada-quote dans les notes du devis.",
    "addedTitle": "Ada-quote a ajouté des produits à la commande",
    "addedIntro": "Lors de la valorisation, Ada-quote a ajouté des produits absents de la liste. Décidez s’ils restent dans la commande et, si vous le souhaitez, indiquez leur prix.",
    "addedKeep": "Conserver",
    "addedRemove": "Retirer",
    "addedPrice": "Prix unitaire (€)",
    "addedPriceHelp": "Vide : le prix d’Ada-quote est conservé ({{price}}).",
    "addedAdaPrice": "Prix Ada-quote : {{price}}",
    "addedSave": "Enregistrer la décision",
    "addedLater": "Plus tard",
    "addedChange": "Modifier",
    "addedRemoved": "Retirée de la commande",
    "addedPriceChanged": "Prix indiqué par Commandes",
    "addedPending": "Décidez si vous conservez les produits ajoutés par Ada-quote avant de continuer.",
    "addedAdjusted": "Montants ajustés selon votre décision sur les produits ajoutés par Ada-quote. La décision est envoyée à Ada-quote dans les notes de la commande.",
    "addedPriceInvalid": "Indiquez un prix valide (par exemple 25 ou 25,50).",
    "totalsTitle": "Récapitulatif des montants",
    "subtotal": "Montant brut",
    "discount": "Remise totale",
    "netSubtotal": "Sous-total net",
    "tax": "Taxes",
    "total": "Total",
    "quoteReference": "Devis",
    "continue": "Vérifié, passer à la confirmation",
    "ready": "Valorisation reçue. Vérifiez les montants avant de continuer.",
    "waiting": "Une valorisation en cours de validité doit être disponible et vérifiée."
  },
  "errors": {
    "valuationUncertain": "Le résultat de la consultation n’a pas pu être confirmé. La tentative est conservée et ne sera pas renvoyée automatiquement.",
    "valuationIntegrationPending": "La valorisation attend l’intégration avec Ada-quote. Aucun prix n’est encore disponible pour cette commande.",
    "valuationUnavailable": "La valorisation ne peut pas être consultée actuellement. Réessayez.",
    "valuationInvalid": "La valorisation ne correspond pas à cette liste ou contient des données économiques invalides.",
    "valuationChanged": "La valorisation ou la liste a changé. Actualisez et vérifiez les montants.",
    "valuationAdditionalLinesPending": "Décidez si vous conservez les produits ajoutés par Ada-quote avant de continuer.",
    "valuationNotApplicable": "Cette étape est réservée aux demandes avec un client affecté.",
    "valuationReviewRequired": "Obtenez et vérifiez une valorisation valide avant de confirmer la commande.",
    "requesterEmailUnavailable": "L’adresse e-mail de l’utilisateur à l’origine de l’envoi ne peut pas être vérifiée. Vérifiez son compte avant de continuer.",
    "customerAssignmentNotEnabled": "Les données de la commande sont enregistrées. L’envoi commercial attend l’intégration Ada-quote.",
    "customerAssignmentUnavailable": "L’affectation des clients n’est pas encore activée dans cet environnement.",
    "customerAssignmentChanged": "Les données du client ont changé. Recherchez et sélectionnez à nouveau le client et son adresse avant d’enregistrer.",
    "customerAssignmentAddressInvalid": "L’adresse sélectionnée n’appartient pas à ce client ou n’est plus disponible.",
    "deliveryDateInPast": "La date de livraison ne peut pas être antérieure à aujourd’hui.",
    "customerAssignmentIncomplete": "Sélectionnez un client et son adresse de livraison avant d’enregistrer les données de commande.",
    "customerAssignmentRequired": "Choisissez le client et son adresse de livraison pour créer la demande.",
    "customerDirectoryUnavailable": "Le référentiel clients d’Atlas est indisponible.",
    "customerDirectoryChanged": "Le référentiel clients a changé. Sélectionnez à nouveau le client et son adresse avant d’enregistrer les modifications.",
    "customerDirectoryNotFound": "Atlas ne trouve pas le client ou la route de consultation.",
    "customerDirectoryInvalid": "Atlas a renvoyé une réponse clients non valide.",
    "atlasTestUnavailable": "Atlas Test est indisponible ou sa connexion a changé. Aucune autre API ne sera utilisée automatiquement.",
    "atlasTestIdentity": "Le serveur ne confirme pas son identité Atlas Test. Vérifiez la configuration avant l’analyse.",
    "atlasTestFormatUnsupported": "Atlas Test ne confirme pas encore la prise en charge de tous les formats de cette demande.",
    "atlasTestCommercialDisabled": "Cette demande appartient à Atlas Test et ne peut pas envoyer de devis ni de commandes.",
    "installationVerificationRequired": "Atlas doit vérifier la liste actuelle avant la confirmation de la demande.",
    "installationInvalidResponse": "La proposition renvoyée par Atlas ne peut pas être validée. Aucun matériel n’a été envoyé.",
    "installationUnavailable": "La planification des installations n’est pas encore disponible sur cette connexion Atlas. Votre description est enregistrée.",
    "installationFailed": "Atlas n’a pas pu terminer cette opération. Vous pouvez réessayer sans envoyer le devis.",
    "installationChanged": "La demande ou la vérification Atlas a changé. Actualisez la page pour continuer avec la version actuelle.",
    "installationRequiresEmptyDraft": "Cette méthode nécessite une demande sans documents ni matériel provenant d’une autre méthode. Conservez cette demande et créez-en une nouvelle.",
    "installationCatalogChanged": "Un produit ou son unité ne correspond plus au catalogue actuel. Vérifiez la sélection avant de continuer.",
    "identityOptionsChanged": "Atlas a actualisé les alternatives. Vérifiez les options actuelles et choisissez à nouveau.",
    "identitySelectionRequired": "Sélectionnez une alternative d’Atlas ou indiquez qu’aucune ne correspond.",
    "catalogProductRequired": "Choisissez un produit du catalogue pour remplacer la suggestion d’Atlas.",
    "mandatoryDependenciesInvalid": "Les licences n’ont pas été appliquées : réponse invalide ou proposition modifiée. Relancez l’analyse.",
    "pendingUnits": "Certaines unités doivent être confirmées.",
    "pendingQuantities": "Certaines quantités restent à préciser. Vérifiez-les avant de poursuivre le devis.",
    "unitProvenanceProtected": "Ces lignes conservent les unités du document original. Modifiez-les individuellement ; la liste complète ne peut pas être remplacée en mode manuel.",
    "adaQuoteCustomerDataMissing": "Atlas attend les données complètes du client avant l’envoi à AdaQuote.",
    "submissionRetryUnsafe": "Impossible de renvoyer sans confirmer qu’AdaQuote n’a pas reçu la demande. Actualisez l’état.",
    "submissionChecking": "Vérification du renvoi. Actualisez l’état avant de réessayer.",
    "accountBlocked": "Votre compte n'est pas actif. Contactez Adaltra.",
    "accountPending": "Votre compte est en attente de validation par Adaltra. Nous vous préviendrons par e-mail.",
    "assistantDisabled": "L’assistant est désactivé dans cet environnement.",
    "assistantFailed": "L’assistant n’a pas pu répondre. Réessayez.",
    "assistantSessionLost": "Cette conversation n’est plus disponible.",
    "assistantTimeout": "L’assistant a mis trop de temps à répondre.",
    "assistantUnavailable": "Nous n’avons pas pu joindre l’assistant.",
    "badRequest": "La demande n'est pas valide.",
    "badSignature": "La signature n’est pas valide.",
    "budgetExpired": "Le devis a expiré et ne peut pas être approuvé.",
    "budgetNotExtendable": "Ce devis ne peut plus être prolongé.",
    "budgetNotFound": "Nous n'avons pas trouvé ce devis.",
    "budgetNotRemindable": "Ce devis n’attend pas de décision.",
    "companyEditForbidden": "Seul le gestionnaire du compte peut modifier ces informations.",
    "companyNotFound": "Nous n'avons pas trouvé cette entreprise.",
    "conflict": "Cette opération ne peut pas aboutir pour le moment.",
    "conversationNotFound": "Cette conversation n’est plus disponible.",
    "currentPasswordInvalid": "Le mot de passe actuel est incorrect.",
    "documentNotReady": "Le document n'est pas encore disponible.",
    "duplicate": "Cet enregistrement existe déjà.",
    "emailAlreadyRegistered": "Cette adresse est déjà enregistrée.",
    "fileNotFound": "Nous n'avons pas trouvé ce fichier.",
    "fileTooLarge": "Le fichier dépasse la taille maximale autorisée.",
    "documentInvalid": "L'un des fichiers est endommagé ou ne correspond pas à son extension, Atlas ne peut donc pas le lire. Ouvrez-le, enregistrez-le à nouveau (ou exportez-le de nouveau en PDF/Excel) et téléversez-le à nouveau.",
    "documentUnsupported": "Atlas ne peut pas lire l'un des fichiers à cause de son type. Téléversez-le en PDF, Excel (XLSX/XLS), CSV ou image.",
    "documentEmpty": "L'un des fichiers est vide. Vérifiez le fichier et téléversez-le à nouveau.",
    "forbidden": "Vous n'avez pas l'autorisation d'effectuer cette action.",
    "genericText": "Nous avons enregistré le problème. Vous pouvez réessayer.",
    "releaseNotFound": "Nous n’avons pas trouvé cette version.",
    "platformRequestNotFound": "Nous n’avons pas trouvé cette demande d’amélioration.",
    "genericTitle": "Quelque chose s'est mal passé",
    "hermesDisabled": "L’intégration Atlas est désactivée.",
    "hermesIncomplete": "Renseignez l’adresse et la clé d’API avant de l’activer.",
    "smtpIncomplete": "Configurez une URL SMTP ou un serveur avant d’activer l’e-mail.",
    "smtpNotConfigured": "Le service SMTP n’est pas configuré ou est désactivé.",
    "emailAudienceEmpty": "Aucun utilisateur actif ne possède le rôle sélectionné.",
    "pushIncomplete": "Configurez les clés VAPID et le contact du service avant d’activer les notifications push.",
    "hermesNotReady": "L’intégration Atlas n’est pas configurée.",
    "hermesRejected": "Atlas a refusé le travail.",
    "hermesRequestRefAlreadySubmitted": "Ce numéro a déjà été utilisé pour une autre demande dans AdaQuote. Votre liste est enregistrée et nécessite un nouveau numéro pour être envoyée.",
    "hermesRequestRefConflict": "Atlas possède déjà une autre liste liée à ce numéro de demande. Vos matériels sont enregistrés ; contactez Adaltra pour vérifier l’envoi.",
    "recognitionUpdatedConcurrently": "La demande a été mise à jour dans une autre session. Fermez ce formulaire et rechargez la page avant de continuer.",
    "documentReviewChanged": "La révision ou le catalogue Atlas a changé. Rechargez la demande et vérifiez la liste avant de continuer.",
    "documentReviewRejected": "Atlas n’a pas pu accepter la confirmation de la liste. Vos produits sont conservés. L’intégration doit être vérifiée.",
    "hermesTimeout": "Atlas n’a pas répondu à temps.",
    "hermesUnreachable": "Impossible de se connecter à Atlas.",
    "invalidCredentials": "L'e-mail ou le mot de passe est incorrect.",
    "invalidEmail": "Cette adresse e-mail n'est pas valide.",
    "invalidIdentifier": "Cet identifiant n'est pas valide.",
    "invalidProductReference": "La référence du produit n’est pas valide.",
    "invalidQuantity": "Cette quantité n'est pas valide.",
    "invalidTransition": "Cette action est impossible dans l'état actuel.",
    "lineNotFound": "Nous n'avons pas trouvé cette ligne.",
    "includedComponentReadOnly": "Ce composant est inclus. Modifiez le rack parent pour mettre à jour sa quantité.",
    "includedComponentUnbound": "Une ligne ACC SRP ne possède pas de rack parent vérifié. Une révision explicite est nécessaire avant de continuer.",
    "invalidEquivalenceConfirmation": "Cette ligne ne contient pas d’équivalence pouvant être validée.",
    "network": "Impossible de joindre le serveur. Vérifiez votre connexion.",
    "serviceUnavailable": "Le service est en cours de rétablissement. Patientez quelques secondes puis réessayez.",
    "noFilesProvided": "Ajoutez au moins un fichier.",
    "noFilesToProcess": "Ajoutez au moins un document avant de lancer le traitement.",
    "noLinesToSubmit": "Ajoutez au moins une ligne avant d'envoyer.",
    "pendingProducts": "Identifiez tous les produits en attente avant de continuer.",
    "pendingAtlasSuggestions": "Confirmez, modifiez ou retirez les produits suggérés par Atlas avant de continuer.",
    "documentReviewPending": "Terminez la vérification des lectures du document avant de continuer.",
    "pendingEquivalences": "Validez les équivalences proposées avant de continuer.",
    "notFound": "Nous n'avons pas trouvé ce que vous cherchiez.",
    "notificationNotFound": "Nous n'avons pas trouvé cette notification.",
    "pushNotConfigured": "Les notifications push ne sont pas configurées sur le serveur.",
    "oauthEmailNotVerified": "L'adresse e-mail de ce compte n'est pas vérifiée.",
    "oauthFailed": "Nous n'avons pas pu finaliser la connexion. Réessayez.",
    "oauthNoEmail": "Le fournisseur n'a pas transmis d'adresse e-mail.",
    "oauthSessionLost": "La session de connexion a expiré. Réessayez.",
    "onlyDraftsCanBeDeleted": "Seuls les brouillons peuvent être supprimés.",
    "onlyDraftsOrCancelledCanBeDeleted": "Seuls les brouillons ou les demandes annulées peuvent être supprimés.",
    "requestNotCancelled": "La demande n’est pas annulée.",
    "cancellationExpired": "Le délai de réactivation de la demande est terminé.",
    "cancellationCannotBeUndone": "Cette annulation ne peut pas être réactivée.",
    "pageNotFoundText": "Le lien que vous avez suivi n'existe pas ou a changé d'adresse.",
    "pageNotFoundTitle": "Page introuvable",
    "passwordTooLong": "Ce mot de passe est trop long.",
    "passwordTooShort": "Le mot de passe doit comporter au moins 10 caractères.",
    "passwordTooSimple": "Le mot de passe doit associer lettres et chiffres.",
    "passwordsDontMatch": "Les mots de passe ne correspondent pas.",
    "productImageNotFound": "Ce produit n’a pas d’image disponible.",
    "providerNotConfigured": "Cette méthode de connexion n'est pas disponible pour l'instant.",
    "registrationAlreadyReviewed": "Cette demande d'inscription a déjà été examinée.",
    "registrationNotFound": "Nous n'avons pas trouvé cette demande d'inscription.",
    "requestNotEditable": "Cette demande ne peut plus être modifiée.",
    "requestNotFound": "Nous n'avons pas trouvé cette demande.",
    "requiredField": "Ce champ est obligatoire.",
    "resetLinkInvalid": "Le lien a expiré ou a déjà été utilisé.",
    "routeNotFound": "Cette adresse n'existe pas.",
    "ticketNotFound": "Nous n’avons pas trouvé ce ticket.",
    "tooManyAttempts": "Trop de tentatives. Patientez quelques minutes et réessayez.",
    "tooManyFiles": "Vous avez atteint le nombre maximal de fichiers.",
    "tooManyMessages": "Vous avez envoyé trop de messages d’affilée. Patientez un instant.",
    "unauthorized": "Votre session a expiré. Reconnectez-vous.",
    "unexpected": "Une erreur est survenue. Veuillez réessayer.",
    "userNotFound": "Cet utilisateur est introuvable.",
    "cannotModifyOwnAccess": "Vous ne pouvez pas retirer votre propre accès administrateur.",
    "unknownProvider": "Cette méthode de connexion n'existe pas.",
    "unsupportedFileType": "Ce type de fichier n'est pas pris en charge.",
    "uploadFailed": "Nous n'avons pas pu importer le fichier.",
    "upstream": "Un service externe n’a pas répondu correctement.",
    "validUntilMustBeFuture": "La nouvelle date doit être future.",
    "validation": "Vérifiez les informations saisies.",
    "adaQuoteIncomplete": "Renseignez l’adresse et la clé avant de l’activer.",
    "adaQuoteCustomerCodeMissing": "Le code client AdaQuote manque dans les données de votre entreprise.",
    "adaQuoteReadFailed": "Impossible de récupérer vos devis dans Ada-quote. Réessayez.",
    "adaQuotePdfNotReady": "Le PDF de ce devis n’est pas encore disponible. Réessayez plus tard ou contactez l’administration.",
    "adaQuotePdfCustomerMismatch": "Le devis ne correspond pas au code client de cette demande. Contactez l’administration.",
    "adaQuotePdfUnavailable": "Impossible de récupérer le PDF du devis. Réessayez.",
    "adaQuotePdfInvalid": "Aucun PDF valide n’a été reçu.",
    "atlasPdfUnavailable": "Atlas ne peut pas encore fournir le PDF du devis. Réessayez plus tard.",
    "atlasPdfIdentityConflict": "Atlas a renvoyé une identité de devis différente. Le document ne sera pas affiché ; contactez l’administration.",
    "adaQuotePdfNotValidated": "Le PDF sera disponible après la validation commerciale.",
    "hermesSignatureRequired": "L’envoi automatique nécessite le secret de signature.",
    "catalogMasterChanged": "Le maître tarifaire a changé pendant la copie. Réessayez.",
    "catalogTooManyPages": "La copie du catalogue ne se termine pas. Vérifiez la connexion à Atlas.",
    "catalogNoVersion": "Atlas n’a pas indiqué quelle version du maître il possède.",
    "catalogProductUnavailable": "Le produit sélectionné n’est plus disponible dans le catalogue. Actualisez les options et réessayez.",
    "recognitionUnusable": "Atlas a renvoyé un résultat que le portail n’a pas pu enregistrer. Réessayez.",
    "recognitionVisualAnalysisUnavailable": "L’analyse visuelle d’Atlas est indisponible pour le moment. Vos fichiers sont enregistrés ; vous pourrez réessayer plus tard sans les remplacer.",
    "recognitionFailed": "La reconnaissance a échoué.",
    "documentAnalysisUnavailable": "Atlas n’a pas pu démarrer l’analyse. Vos fichiers sont enregistrés ; vous pouvez réessayer plus tard sans les téléverser à nouveau.",
    "recommendationsRejected": "Atlas n’a pas pu démarrer l’analyse des recommandations.",
    "recommendationsNeedRecognition": "Cette liste n’a pas encore de résultat qu’Atlas puisse analyser.",
    "recommendationsNotReady": "Les recommandations ne sont pas encore prêtes.",
    "recommendationNotFound": "Cette recommandation n’est plus disponible.",
    "recommendationAlreadyDecided": "Cette recommandation a déjà été examinée.",
    "recommendationNeedsInput": "Répondez d’abord aux questions en attente.",
    "recommendationMissingProduct": "Atlas n’a associé aucun produit valide à cette recommandation.",
    "recommendationCatalogStale": "Le catalogue a changé. Relancez l’analyse.",
    "recommendationReplacementMissing": "Atlas n’a pas indiqué quel produit doit être remplacé. Relancez l’analyse.",
    "recommendationsPending": "Examinez les recommandations Atlas avant l’envoi.",
    "recommendationQuestionsPending": "Répondez aux questions Atlas avant de continuer.",
    "recommendationDecisionsPending": "Ajoutez ou écartez chaque recommandation avant de continuer.",
    "unitReviewChanged": "La ligne a changé depuis son ouverture. Rechargez la demande et vérifiez à nouveau son unité.",
    "unitAnswerUnresolved": "Atlas n’a pas confirmé l’unité choisie. La question reste en attente ; votre sélection n’a pas été appliquée.",
    "quantityAnswerUnresolved": "Atlas n’a pas encore appliqué la quantité saisie. La vérification reste en attente ; réessayez.",
    "installationReferenceSize": "Les fichiers de référence peuvent atteindre 10 Mo chacun et 20 Mo au total.",
    "installationReferenceInvalid": "Le fichier de référence ne peut pas être lu. Vérifiez que le PDF ou l’image est valide.",
    "installationReferenceLocked": "Pour modifier les fichiers, revenez à la description et lancez une nouvelle analyse.",
    "installationReferencesUnavailable": "Cette connexion Atlas ne prend pas encore en charge les fichiers de référence. Vos fichiers et votre description sont enregistrés.",
    "requestChangedConcurrently": "La demande a changé pendant l'enregistrement. Actualisez la page et réessayez.",
    "semanticResolutionFailed": "Atlas n'a pas pu terminer l'interprétation. Réessayez ou vérifiez le document.",
    "visualReviewConfirmationRequired": "Atlas ne considère pas encore la lecture de la photo comme confirmée. Utilisez « Réanalyser » dans le menu de la demande pour la relire et la confirmer.",
    "readingConnectionChanged": "La connexion de lecture de cette demande a changé. L'analyse ne sera pas envoyée vers une autre destination.",
    "simpleReadingUnavailable": "La lecture simplifiée n'est pas disponible. La demande ne basculera pas automatiquement vers une autre connexion.",
    "simpleReadingFormatUnsupported": "La lecture simplifiée accepte les PDF et les images ; ce type de fichier n'est pas encore disponible.",
    "simpleReadingImagesUnchecked": "Impossible de vérifier si Atlas lit les images. Vos fichiers sont toujours enregistrés ; réessayez.",
    "simpleReadingImagesDisabled": "Atlas ne lit pas encore les images en lecture simplifiée. Votre photo est toujours enregistrée ; vous pourrez l'analyser dès que ce sera disponible.",
    "readingConnectionLocked": "Cette demande est déjà liée à sa connexion de lecture. Créez une autre demande pour comparer.",
    "processingRequestChanged": "La demande a changé. Actualisez la page avant de lancer l'analyse.",
    "recognitionJobGone": "Atlas ne dispose plus de cette analyse. Vos fichiers sont toujours enregistrés ; relancez l'analyse.",
    "recognitionServiceUnavailable": "Atlas ne répond plus au sujet de cette analyse depuis plusieurs minutes. Vos fichiers sont toujours enregistrés ; réessayez plus tard.",
    "recognitionStartInterrupted": "Nous n’avons pas pu confirmer le démarrage de l’analyse. Vos fichiers sont toujours enregistrés ; relancez l’analyse.",
    "recognitionNotRestarted": "Atlas n’a pas lancé de nouvelle lecture car il conserve encore la précédente. Patientez quelques minutes puis relancez l’analyse.",
    "typedTextEmpty": "Saisissez d’abord votre liste ou la description de votre installation.",
    "typedTextInvalidCharacters": "Le texte contient des caractères qu’Atlas ne peut pas lire (par exemple des caractères de contrôle collés depuis un autre programme). Supprimez-les et renvoyez-le.",
    "typedTextTooLarge": "Le texte est trop long pour qu’Atlas le lise en une fois (4 000 caractères et 16 Ko au maximum). Raccourcissez-le ou répartissez-le sur plusieurs demandes.",
    "typedTextTooManyLines": "Le texte comporte trop de lignes pour qu’Atlas le lise en une fois (300 au maximum). Regroupez des lignes ou répartissez-le sur plusieurs demandes.",
    "typedTextRequiresOneFile": "Atlas lit le texte saisi seul, sans autres documents. Retirez les documents ou envoyez le texte dans une autre demande.",
    "typedTextNoMaterials": "Atlas n’a trouvé aucun produit dans le texte. Vérifiez-le (par exemple « 20 prises cat6 ») ou décrivez-le comme une installation.",
    "typedTextUnsupported": "Cette connexion Atlas ne lit pas encore les textes saisis comme une liste. Envoyez la description comme installation ou remplissez la liste manuellement.",
    "twoFactorInvalid": "Code incorrect. Réessayez.",
    "twoFactorExpired": "Ce code a expiré ou a déjà été utilisé. Connectez-vous à nouveau.",
    "twoFactorLocked": "Trop de tentatives. Patientez 15 minutes avant de réessayer.",
    "twoFactorResendWait": "Patientez avant de demander un autre code. Si tous les renvois sont utilisés, reconnectez-vous.",
    "twoFactorDelivery": "Impossible d’envoyer le code par e-mail. Réessayez plus tard.",
    "closedOrderRecommendationsDisabled": "Les commandes finalisées passent de Révision à Confirmation sans recommandations.",
    "wordConverterUnavailable": "La conversion Word en PDF est indisponible. Importez un PDF ou réessayez plus tard.",
    "wordConversionFailed": "Impossible de convertir le document Word en PDF. Vérifiez qu’il n’est ni endommagé ni protégé par un mot de passe, ou importez un PDF.",
    "resetRequiresActiveUser": "Le changement ne peut être imposé qu’à un compte actif.",
    "passwordChangeRequired": "Un administrateur impose un changement de mot de passe. Ouvrez le lien reçu par e-mail ou demandez-en un via Mot de passe oublié pour vous reconnecter.",
    "cannotForceOwnPasswordReset": "Changez votre mot de passe depuis votre profil.",
    "passwordResetCooldown": "Attendez une minute avant de renvoyer l’e-mail.",
    "passwordResetEmailFailed": "L’e-mail n’a pas pu être envoyé. Le compte n’a pas été bloqué ; vérifiez les paramètres de messagerie et réessayez.",
    "cannotDeleteOwnUser": "Vous ne pouvez pas supprimer votre propre compte.",
    "userSecurityChanged": "Le compte a changé pendant l’opération. Actualisez la liste et réessayez.",
    "customerOrderRequired": "Les demandes avec client attribué s’envoient avec « Gagné et passer en commande ».",
    "customerOrderUnavailable": "Le passage en commande n’est pas encore disponible dans Atlas.",
    "customerOrderInvalid": "Atlas a renvoyé une réponse de commande invalide.",
    "customerOrderConflict": "La demande a changé. Rechargez et réessayez.",
    "customerOrderUnreachable": "Atlas est injoignable. Vous pouvez réessayer : la commande ne sera pas dupliquée.",
    "customerOrderNotApplicable": "Cette demande n’a pas de client attribué.",
    "customerOrderDataMissing": "Il manque la date de livraison ou le numéro de commande client (étape 1) pour passer en commande.",
    "atlasMaintenance": "Atlas est en maintenance. La demande est en file d’attente et sera traitée automatiquement ensuite."
  },
  "help": {
    "title": "Centre d'aide",
    "subtitle": "Vos questions sur le portail et le processus de devis.",
    "guides": "Guides",
    "faq": "Questions fréquentes",
    "contactTitle": "Besoin d'aide ?",
    "contactText": "Expliquez ce qui se passe et indiquez la référence de la demande ou du devis, si vous l’avez.",
    "contactCta": "Contacter l'assistance",
    "guidePhotoTitle": "Comment réussir une photo",
    "guidePhotoIntro": "Obtenez une reconnaissance plus précise en préparant bien chaque image.",
    "guidePhotoStep1": "Posez la liste sur une surface plane et bien éclairée.",
    "guidePhotoStep2": "Cadrez la feuille entière, sans couper les références ni les quantités.",
    "guidePhotoStep3": "Évitez les reflets, les ombres et les photos inclinées.",
    "guidePhotoStep4": "Vérifiez que le texte est lisible avant de continuer.",
    "guidePhotoTip": "S'il y a plusieurs pages, photographiez-les dans l'ordre. Vous pourrez toutes les vérifier avant le traitement.",
    "guideLinesTitle": "Comment corriger les articles",
    "guideLinesIntro": "Vérifiez la lecture du document et le produit sélectionné avant d’envoyer la liste.",
    "guideLinesStep1": "Si Lectures à confirmer apparaît, vérifiez le texte, la quantité et l’unité de chaque ligne. Utilisez modifier pour corriger et confirmer pour enregistrer la lecture.",
    "guideLinesStep2": "Confirmer le texte n’identifie pas toujours le produit. Si Atlas demande de choisir une référence, répondez ou recherchez le produit dans le catalogue par code ou référence.",
    "guideLinesStep3": "Dans la liste des matériels, vérifiez le produit, la quantité et l’unité. Ouvrez modifier pour changer la ligne et confirmez les lignes nécessitant votre validation.",
    "guideLinesStep4": "Retirez ou excluez les matériels non souhaités lorsque l’écran le permet. Résolvez les quantités ou unités en attente avant de continuer.",
    "guideLinesTip": "Une référence bien reconnue ne remplace pas la vérification de la quantité et de l’unité. Vérifiez, par exemple, si un câble est demandé en mètres ou en unités.",
    "guideBudgetTitle": "Comment le devis est établi",
    "guideBudgetIntro": "Découvrez le parcours, de votre liste à la proposition commerciale.",
    "guideBudgetStep1": "Vérifiez les matériels, quantités et unités. Répondez aux questions d’Atlas en attente et décidez des suggestions affichées.",
    "guideBudgetStep2": "À la confirmation, vérifiez le récapitulatif et cochez que vous avez vérifié les matériels et les quantités. Cliquez sur Envoyer la demande pour demander le devis.",
    "guideBudgetStep3": "Suivez l’avancement dans Mes demandes et les notifications. Quand le devis est disponible, ouvrez-le depuis Devis.",
    "guideBudgetStep4": "Vérifiez les prix et conditions. Téléchargez le document lorsqu’il est disponible et utilisez les actions d’approbation, de modification ou de refus proposées.",
    "guideBudgetTip": "Le montant affiché avant l’envoi est une estimation. Vérifiez les prix et conditions du devis généré avant de l’approuver.",
    "guidePrivacyTitle": "Confidentialité de vos documents",
    "guidePrivacyIntro": "Vos fichiers servent uniquement à traiter votre demande.",
    "guidePrivacyStep1": "Les documents sont rattachés à votre compte client.",
    "guidePrivacyStep2": "Seul le personnel autorisé peut en consulter le contenu.",
    "guidePrivacyStep3": "Vous pouvez nous interroger sur leur conservation ou leur suppression.",
    "guidePrivacyStep4": "Nous ne partageons jamais vos fichiers à des fins publicitaires.",
    "guidePrivacyTip": "Consultez la politique de confidentialité complète pour en savoir plus.",
    "faqTimeQ": "Sous quel délai vais-je recevoir mon devis ?",
    "faqTimeA": "Le délai dépend de l’analyse et des vérifications nécessaires. Consultez l’état dans Mes demandes ; vous recevrez une notification en cas de nouveauté.",
    "faqEditQ": "Puis-je modifier une demande déjà envoyée ?",
    "faqEditA": "Une fois envoyée, elle ne peut plus être modifiée, mais vous pouvez écrire à l'assistance en indiquant la référence.",
    "faqFormatsQ": "Quels formats de fichier puis-je importer ?",
    "faqFormatsA": "Vous pouvez importer des images JPG, PNG, WEBP ou HEIC, des PDF et des fichiers XLSX, XLS ou CSV. Plusieurs fichiers sont acceptés par demande ; vérifiez qu’ils sont tous joints avant l’analyse.",
    "faqPriceQ": "Les prix incluent-ils la TVA ?",
    "faqPriceA": "Le détail indique séparément le montant hors taxes et la TVA, ainsi que le total toutes taxes comprises.",
    "shortcuts": "Accès directs",
    "privacyAction": "Voir la politique de confidentialité",
    "guideStartTitle": "Comment créer une demande",
    "guideStartIntro": "Choisissez la méthode adaptée aux informations dont vous disposez.",
    "guideStartStep1": "Cliquez sur Nouvelle demande et renseignez le projet. Conservez la référence SOL pour le retrouver.",
    "guideStartStep2": "Si vous avez une liste, prenez une photo ou importez des fichiers PDF, images, Excel ou CSV. Vous pouvez joindre plusieurs fichiers, par exemple un PDF et une image.",
    "guideStartStep3": "Si vous connaissez les produits, choisissez la saisie manuelle et recherchez par code ou référence. Pour qu’Atlas propose les matériels, choisissez Décrivez votre installation à Atlas.",
    "guideStartStep4": "Vérifiez les matériels et les suggestions. À la confirmation finale, vérifiez le récapitulatif, cochez que vous avez vérifié la liste et cliquez sur Envoyer la demande.",
    "guideStartTip": "Envoyer une description ou importer un fichier lance l’analyse. La demande finale est envoyée après votre vérification.",
    "guideAtlasTitle": "Décrivez votre installation à Atlas",
    "guideAtlasIntro": "Expliquez vos besoins et vérifiez les matériels proposés par Atlas.",
    "guideAtlasStep1": "Dans une nouvelle demande, choisissez Décrivez votre installation à Atlas. Indiquez l’objectif, les zones ou étages, les quantités prévues et les équipements ou câbles existants. Vous pouvez aussi joindre des plans, des photos ou des PDF comme référence.",
    "guideAtlasStep2": "Cliquez sur Envoyer la proposition. S’il manque des détails, ouvrez chaque sujet, répondez aux étapes du dialogue et enregistrez. Une fois les sujets complétés, cliquez sur Envoyer les réponses.",
    "guideAtlasStep3": "Lorsque la proposition est prête, vérifiez le code, la référence, la description et la quantité de chaque matériel. Vous pouvez confirmer, modifier depuis le catalogue ou retirer des lignes.",
    "guideAtlasStep4": "Lisez l’explication des composants et les suggestions d’Atlas. Choisissez les ajouts et attendez la fin de la vérification technique ; toute question restante apparaîtra dans le portail.",
    "guideAtlasStep5": "À la confirmation, vérifiez la liste et le montant disponible. Cochez que vous avez vérifié les matériels et les quantités, puis cliquez sur Envoyer la demande.",
    "guideAtlasTip": "Les matériels provisoires sont un aperçu. Les actions deviennent disponibles quand Atlas termine ses vérifications ; vous pouvez quitter et reprendre la demande.",
    "guideResumeTitle": "Comment reprendre une demande",
    "guideResumeIntro": "Poursuivez une vérification enregistrée et consultez ce qui reste à faire.",
    "guideResumeStep1": "Pendant l’analyse, utilisez Quitter ou Quitter et continuer plus tard. Ouvrez Mes demandes et sélectionnez la référence SOL pour reprendre l’étape en attente.",
    "guideResumeStep2": "Si Atlas traite la demande ou effectue des vérifications techniques, attendez et consultez l’état. Un aperçu des matériels ne signifie pas que la proposition est prête à confirmer.",
    "guideResumeStep3": "Complétez les questions, lectures, quantités ou unités en attente indiquées à l’écran. Consultez aussi les notifications pour suivre les avancées.",
    "guideResumeStep4": "Si une erreur apparaît, utilisez Réessayer lorsque proposé. Si elle persiste, contactez le support avec la référence, l’étape et ce qui s’est passé ; une capture d’écran est utile.",
    "guideResumeTip": "Enregistrez les réponses ou modifications avant de quitter un dialogue. Vérifiez que les confirmations ont fini de s’enregistrer avant de fermer l’écran.",
    "faqReadingQ": "Pourquoi dois-je confirmer une lecture ?",
    "faqReadingA": "Atlas peut demander de valider un texte, une quantité ou une unité du document. Confirmer la lecture enregistre ces données ; si le produit reste à identifier, une question permettra de le sélectionner.",
    "faqSavedQ": "Puis-je quitter pendant qu’Atlas travaille ?",
    "faqSavedA": "Oui. La demande est enregistrée et peut être reprise depuis Mes demandes. Enregistrez d’abord les modifications des dialogues et attendez la fin des confirmations en cours.",
    "faqPendingQ": "Que signifie En attente d’Atlas ?",
    "faqPendingA": "Atlas termine encore l’analyse ou ses vérifications. S’il n’y a pas de question pour vous, consultez l’état plus tard. Les matériels provisoires ne sont pas validables avant que la proposition soit prête.",
    "faqUnavailableQ": "Pourquoi un lien indique-t-il que la demande ou le devis est indisponible ?",
    "faqUnavailableA": "L’élément peut avoir été supprimé ou le lien être incorrect. Retournez à sa liste pour le retrouver. Si vous attendiez un accès et qu’il n’apparaît pas, contactez le support avec la référence."
  },
  "languages": {
    "es": "Español",
    "en": "English",
    "fr": "Français",
    "it": "Italiano"
  },
  "lineConfidence": {
    "high": "Reconnaissance fiable",
    "review": "Référence à vérifier",
    "incomplete": "Donnée incomplète",
    "corrected": "Corrigée par vous",
    "confirmed": "Confirmé",
    "manual": "Saisie manuellement"
  },
  "nav": {
    "home": "Accueil",
    "newRequest": "Nouvelle demande",
    "requests": "Demandes",
    "budgets": "Devis",
    "assistant": "Assistant Atlas",
    "admin": "Administration",
    "notifications": "Notifications",
    "help": "Aide",
    "profile": "Profil",
    "support": "Assistance",
    "privacy": "Confidentialité",
    "signOut": "Se déconnecter",
    "signingOut": "Déconnexion…",
    "mobileNew": "Nouvelle",
    "mobileHome": "Accueil",
    "mobileRequests": "Demandes",
    "mobileBudgets": "Devis",
    "mobileAssistant": "Assistant",
    "mobileProfile": "Profil",
    "changeLanguage": "Changer de langue",
    "mainNavigation": "Navigation principale",
    "mobileNavigation": "Navigation mobile",
    "hideSidebar": "Replier le menu",
    "showSidebar": "Déplier le menu",
    "preferences": "Préférences",
    "legalNotice": "Mentions légales",
    "cookies": "Cookies",
    "legalInformation": "Informations légales"
  },
  "notifications": {
    "budgetApprovedBody": "Vous avez approuvé {{ref}} · {{project}}. Adaltra prépare la commande.",
    "budgetApprovedTitle": "Devis approuvé",
    "budgetChangesBody": "Adaltra va revoir {{ref}} · {{project}} et vous enverra une proposition corrigée.",
    "budgetChangesTitle": "Modifications demandées",
    "budgetExpiringBody": "Approuvez-le avant la date de validité.",
    "budgetExpiringTitle": "Le devis {{ref}} expire bientôt",
    "budgetExtendedBody": "Nous avons prolongé la validité de {{ref}}. Vous avez plus de temps pour décider.",
    "budgetExtendedTitle": "Devis prolongé",
    "budgetReadyBody": "Vous pouvez le consulter et le télécharger.",
    "budgetReadyTitle": "Votre devis {{ref}} est prêt",
    "budgetRejectedBody": "Vous avez refusé {{ref}} · {{project}}.",
    "budgetRejectedTitle": "Devis refusé",
    "budgetReminderBody": "{{ref}} attend toujours votre décision.",
    "budgetReminderTitle": "Un devis vous attend",
    "budgetWithdrawnBody": "{{ref}} n’est plus disponible. Écrivez-nous s’il vous intéresse toujours.",
    "budgetWithdrawnTitle": "Devis retiré",
    "emptyText": "Nous vous préviendrons ici dès qu'il y aura du nouveau.",
    "emptyTitle": "Vous n'avez aucune notification",
    "markAllRead": "Tout marquer comme lu",
    "panelError": "Nous n’avons pas pu charger les notifications.",
    "panelUnread": "{{count}} non lues",
    "viewAll": "Voir toutes les notifications",
    "settingsButton": "Réglages",
    "settingsTitle": "Réglages des notifications",
    "deleteAll": "Supprimer",
    "deleteConfirmText": "Tout l’historique des notifications sera supprimé. Cette action est irréversible.",
    "deleteConfirmTitle": "Supprimer toutes les notifications ?",
    "channelsTitle": "Des alertes sur tous vos appareils",
    "channelsText": "Les e-mails et les push suivent vos préférences. Activez les push sur chaque appareil souhaité.",
    "enablePush": "Activer le push",
    "disablePush": "Désactiver le push",
    "pushChecking": "Vérification du push",
    "pushInactive": "Push désactivé",
    "pushBlocked": "Push bloqué",
    "pushUnavailable": "Push indisponible",
    "channelsTextActive": "Les notifications push sont activées sur cet appareil et suivent vos préférences. Vous pouvez les désactiver à tout moment.",
    "pushActive": "Push actif",
    "pushEnabled": "Les notifications push sont activées sur cet appareil.",
    "pushDisabled": "Les notifications push sont désactivées sur cet appareil.",
    "pushDenied": "Votre navigateur bloque les notifications Atlas.",
    "pushError": "Impossible de modifier les paramètres des notifications push.",
    "pushRequiresHttps": "Les notifications push et l’installation nécessitent une connexion HTTPS sécurisée.",
    "pushNotConfigured": "Les clés VAPID du serveur manquent pour activer les notifications push.",
    "emailNotConfigured": "Le serveur SMTP doit être configuré pour envoyer des e-mails.",
    "installApp": "Installer l’app",
    "appInstalled": "App installée",
    "installHint": "Sur iPhone ou iPad, utilisez Partager → Sur l’écran d’accueil.",
    "quoteFailedBody": "Un problème est survenu avec {{ref}}. Nous vérifions.",
    "quoteFailedTitle": "Nous n’avons pas pu préparer le devis",
    "quoteReadyBody": "{{ref}} peut désormais être consulté et accepté.",
    "quoteInReviewTitle": "Votre devis est en cours de revue",
    "quoteInReviewBody": "{{ref}} est consultable. Un commercial le vérifie avant de vous l’envoyer.",
    "quoteRejectedByAdaQuoteBody": "{{ref}} n’a pas été validé lors de la revue commerciale.",
    "quoteRejectedByAdaQuoteTitle": "Devis non approuvé",
    "quoteReadyTitle": "Votre devis est prêt",
    "requestProcessedBody": "Atlas a préparé {{ref}}. Vérifiez les produits avant de l’envoyer.",
    "requestProcessedTitle": "Demande en attente de vérification",
    "requestReadingFailedTitle": "Échec de l’analyse des documents",
    "requestReadingFailedBody": "Atlas n’a pas pu terminer l’analyse de {{ref}}. Ouvrez la demande pour consulter l’erreur et réessayer.",
    "requestReceivedBody": "Atlas a commencé à préparer votre devis.",
    "requestReceivedTitle": "Demande {{ref}} reçue",
    "requestSubmittedBody": "{{ref}} · {{project}} est entre les mains d’Atlas.",
    "requestSubmittedTitle": "Demande envoyée",
    "subtitle": "Tout ce qui s'est passé sur vos demandes et vos devis.",
    "title": "Notifications",
    "unread": "Non lues",
    "maintenanceQueueStartedTitle": "Demande envoyée à Atlas",
    "maintenanceQueueStartedBody": "La maintenance est terminée et {{ref}} est en cours de traitement.",
    "maintenanceQueueFailedTitle": "La demande en file n’a pas pu être traitée",
    "maintenanceQueueFailedBody": "{{ref}} n’a pas pu être envoyée à Atlas après la maintenance. Ouvrez-la et cliquez de nouveau sur « Analyser »."
  },
  "privacy": {
    "title": "Politique de confidentialité",
    "subtitle": "Comment nous traitons les informations que vous partagez avec Adaltra.",
    "section1Title": "Données que nous collectons",
    "section1Text": "Les coordonnées de votre compte, celles de votre entreprise et les documents que vous importez pour préparer un devis.",
    "section2Title": "À quoi elles servent",
    "section2Text": "Uniquement à traiter vos demandes, établir les devis et vous accompagner. Nous ne les cédons jamais à des fins publicitaires.",
    "section3Title": "Conservation",
    "section3Text": "Nous conservons les documents pendant la durée de la relation commerciale et selon les délais imposés par la réglementation fiscale.",
    "section4Title": "Vos droits",
    "section4Text": "Vous pouvez demander l'accès, la rectification ou la suppression de vos données en écrivant à notre équipe d'assistance."
  },
  "profile": {
    "title": "Votre profil",
    "subtitle": "Gérez vos informations et celles de votre entreprise.",
    "personalData": "Informations personnelles",
    "companyData": "Informations de l'entreprise",
    "security": "Sécurité",
    "preferences": "Préférences",
    "language": "Langue",
    "languageHint": "Elle s'appliquera à tout le portail et aux e-mails que vous recevrez.",
    "address": "Adresse",
    "city": "Ville",
    "postalCode": "Code postal",
    "province": "Département",
    "adaQuoteCustomerCode": "Code client AdaQuote",
    "adaQuoteCustomerCodeHint": "Code commercial attribué à votre entreprise dans AdaQuote.",
    "adaQuoteCustomerCodeReadOnlyHint": "Code commercial attribué par Adaltra. Vous pouvez le consulter, mais seul un administrateur peut le modifier.",
    "linkedAccounts": "Comptes liés",
    "linkedAccountsHint": "Vous pouvez accéder au portail avec l'un ou l'autre.",
    "companyReadOnly": "Seul le gestionnaire du compte peut modifier les données fiscales. Écrivez-nous si besoin.",
    "passwordChanged": "Mot de passe mis à jour",
    "session": "Session",
    "sessionHint": "Fermez la session sur cet appareil."
  },
  "request": {
    "dateNotPast": "Elle ne peut pas être antérieure à aujourd’hui.",
    "orderAssignment": {
      "previewLabel": "Disponible",
      "savedLabel": "Enregistré",
      "savedHint": "Données enregistrées dans la demande.",
      "previewHint": "Sélectionnez le client et son adresse de livraison. Les données seront enregistrées en continuant ou en enregistrant les modifications.",
      "retryConnection": "Réessayer la connexion",
      "noCustomers": "Aucun client correspondant",
      "noAddresses": "Aucune adresse disponible",
      "connecting": "Connexion à Atlas…",
      "searchHint": "Saisissez au moins deux caractères du nom, du code ou du NIF.",
      "sourceCount": "Clients disponibles dans Atlas : {{count}}",
      "staleCopy": "Copie en attente de mise à jour",
      "previewSummaryHint": "Le résumé se met à jour lorsque vous remplissez les champs et sera enregistré avec la demande.",
      "summaryAddress": "Adresse",
      "summaryDate": "Date de livraison",
      "summaryOrderNumber": "Numéro de commande",
      "summaryCustomer": "Client",
      "title": "Affecter le client et l’adresse de livraison",
      "soon": "Prochainement",
      "hint": "La sélection des clients et adresses sera activée lorsque le référentiel Atlas sera disponible.",
      "customer": "Rechercher un client (nom, code ou NIF)",
      "taxId": "NIF",
      "customerHint": "Clients importés depuis Atlas.",
      "address": "Adresse de livraison / expédition (numdir)",
      "addressHint": "Sélectionnez un client pour consulter ses adresses.",
      "date": "Date de livraison (installation)",
      "dateHint": "Date de livraison prévue.",
      "orderNumber": "Numéro de commande client",
      "useProjectName": "Copier le nom du projet",
      "orderHint": "Numéro de commande du client.",
      "summary": "Résumé de la commande",
      "summaryHint": "Lorsque cette fonction sera activée, les informations ci-dessous seront mises à jour à mesure que vous remplirez le formulaire."
    },
    "atlasTestConfirmSubtitle": "Voici la liste issue du test de lecture Atlas Test.",
    "readingConnectionLabel": "Connexion de lecture",
    "readingConnectionCurrent": "Atlas actuel",
    "readingConnectionSimple": "Lecture simplifiée (B)",
    "readingConnectionNotReady": "en attente de configuration",
    "readingConnectionHelp": "Choisissez la connexion avant la première analyse. Créez des demandes distinctes pour comparer le même document.",
    "readingConnectionLocked": "Cette demande conserve sa connexion pendant toute l’analyse et la vérification.",
    "atlasTestNotice": "Test de lecture. Vous pouvez vérifier les résultats ; l’envoi de devis et de commandes est bloqué.",
    "mandatoryDependencyConflict": "Des licences nécessitent une vérification",
    "mandatoryDependencyConflictHint": "Vos lignes ont été conservées. Vérifiez les licences et relancez l’analyse avant de continuer.",
    "mandatoryDependencyWarning": "Atlas a détecté des informations de couverture à vérifier.",
    "confirmAllAndContinue": "Tout confirmer et continuer",
    "continueRecognizedList": "Continuer avec cette liste",
    "continueRecognizedListHint": "Les {{count}} articles du tableau seront conservés, sans ajouter les autres fragments du document.",
    "previousIdentificationStep": "Revenir à l’étape précédente",
    "identifyAction": "Identifier",
    "identifyInTableHint": "Identifiez chaque produit depuis sa ligne. Atlas vous guidera étape par étape.",
    "rackScopeHint": "Affectez chaque composant à son rack ou laissez-le indépendant. Les groupes déjà définis par Atlas ne changeront pas.",
    "rackScopeChoose": "Choisir une destination",
    "rackScopeIndependent": "Indépendant (sans rack)",
    "rackScopeAssigned": "Affectation terminée",
    "rackScopeUnavailable": "Atlas doit compléter les données de cette affectation avant de continuer.",
    "rackScopeLine": "Composant",
    "commercialRejectionSummary": "Consultez le résultat de la validation commerciale.",
    "partialRejectionText": "La validation est terminée. Ces lignes ont été rejetées ; les produits acceptés restent dans le brouillon.",
    "validationCompleted": "Validation commerciale terminée",
    "validationCounts": "Produits acceptés : {{accepted}} · Rejetés : {{rejected}}",
    "validationDraft": "Brouillon {{ref}} créé dans AdaQuote. Le devis définitif et ses prix ne sont pas encore disponibles.",
    "lineRejectedCommercially": "Rejeté par le commercial",
    "lineAcceptedCommercially": "Accepté par le commercial",
    "viewRejectionReasons": "Voir les motifs du refus",
    "rejectionReasonsTitle": "Motifs du refus",
    "rejectionReasonsUnavailable": "Aucun motif supplémentaire n’a été reçu.",
    "commercialRejectionText": "La demande n’a pas été approuvée lors de la validation commerciale. Consultez les motifs reçus ci-dessous.",
    "rejectedLine": "Produit {{number}}",
    "placeOrder": "Passer commande",
    "adaQuotePdfTitle": "PDF du devis · {{number}}",
    "loadingAdaQuotePdf": "Chargement du PDF du devis…",
    "preparationTransition": "Ouverture de l’état de votre demande dans {{count}} s.",
    "customerCodeBlockedHelp": "Un administrateur doit compléter les données du client. Les produits vérifiés sont conservés ; le renvoi reste bloqué jusqu’à résolution.",
    "checkCustomerCode": "Vérifier les données",
    "retrySubmission": "Renvoyer à Atlas",
    "recoverReference": "Récupérer la liste",
    "recoveredReferenceHelp": "La liste porte un nouveau numéro. Vérifiez les matériels et confirmez à nouveau l’envoi. Les documents restent dans la demande originale.",
    "viewOriginalRequest": "Voir la demande originale",
    "customerCodeReady": "Le code client est disponible. Vous pouvez renvoyer la demande à Atlas.",
    "addFile": "Ajouter un fichier",
    "addMoreFiles": "Ajouter d’autres fichiers",
    "addLine": "Ajouter un produit",
    "addLineAfterReading": "Terminez la révision des lectures du document. En attendant, vous pouvez ajouter des produits manuellement.",
    "addRow": "Ajouter une ligne",
    "analyzingHint": "Vous pouvez fermer cette page : le travail continue de notre côté.",
    "analyzingStepIssuing": "Émission du devis",
    "analyzingStepMatching": "Correspondance des références",
    "analyzingStepPricing": "Application des prix",
    "analyzingStepReceived": "Liste reçue",
    "analyzingText": "Nous avons reçu votre liste et la chiffrons. Nous vous préviendrons dès que le devis sera prêt.",
    "analyzingTitle": "Atlas prépare votre devis",
    "commercialReviewHint": "Nous vous préviendrons une fois la vérification terminée.",
    "commercialReviewStepAnalyzing": "Vérification commerciale en cours",
    "commercialReviewStepChecking": "Vérification des produits et des conditions",
    "commercialReviewStepReceived": "Reçu par l’équipe commerciale",
    "commercialReviewStepValidating": "Validation de la proposition",
    "commercialReviewText": "Un commercial vérifie la proposition avant de vous l’envoyer.",
    "commercialReviewTitle": "Votre devis est en cours de revue",
    "backHome": "Revenir à l'accueil",
    "cancelDialogText": "Adaltra cessera de la traiter. Vous pourrez la réactiver pendant 7 jours ; elle et ses documents seront ensuite définitivement supprimés.",
    "cancelDialogTitle": "Annuler cette demande ?",
    "cancelProcess": "Annuler le processus",
    "cancelProcessEmptyText": "Vous reviendrez à l’accueil. Aucune demande ne sera supprimée, car vous n’avez encore enregistré aucune donnée.",
    "cancelProcessTitle": "Annuler ce processus ?",
    "cancelRequest": "Annuler la demande",
    "cancelledMessage": "Demande annulée",
    "cancelledCleanupNotice": "Cette demande sera automatiquement supprimée le {{date}}. Vous pouvez la réactiver jusque-là.",
    "cancelledCleanupList": "Sera automatiquement supprimée le {{date}}",
    "deletePermanently": "Supprimer définitivement",
    "permanentDeleteTitle": "Supprimer définitivement cette demande ?",
    "permanentDeleteText": "« {{name}} » et ses documents vont être supprimés maintenant. Vous ne pourrez plus réactiver la demande ni annuler cette action.",
    "permanentlyDeleted": "Demande supprimée définitivement",
    "changeMethod": "Changer de méthode",
    "chooseMethod": "Choisissez comment ajouter les produits. Vous pourrez vérifier et modifier la liste avant de demander le devis.",
    "confirmCheck": "J'ai vérifié la liste et je confirme que les informations sont correctes.",
    "confirmBeforeSubmit": "Confirmez que vous avez vérifié la liste avant d'envoyer la demande.",
    "confirmNavigation": "Navigation de confirmation",
    "confirmPendingFooter": "Confirmez la liste",
    "confirmReadyFooter": "Prêt à envoyer",
    "confirmSubtitle": "Voici la liste que nous enverrons à Atlas pour préparer votre devis.",
    "confirmTitle": "Confirmez votre demande",
    "estimatedPvpTitle": "Estimation du prix public",
    "estimatedSubtotal": "Prix public hors TVA",
    "estimatedVat": "TVA ({{rate}} %)",
    "estimatedTotal": "Total TVA comprise",
    "estimatedTotalPartial": "Total partiel TVA comprise",
    "estimatedNoValuedLines": "Estimation en attente : aucun produit n’a encore été chiffré.",
    "estimatedPvpNote": "Total approximatif calculé au prix catalogue, sans remise appliquée.",
    "estimatedUnpricedIntro": "Produits restant à chiffrer :",
    "estimatedUnpricedProduct": "{{product}} — Prix public : {{price}}",
    "estimatedUnpricedReasonProduct": "{{product}} — {{reasons}}",
    "estimatedQuantityPending": "Quantité en attente",
    "estimatedCommercialBasisPending": "Unité d’achat en revue commerciale",
    "estimatedUnitPending": "Unité en attente",
    "estimatedUnpricedPriceReason": "Prix public : {{price}}",
    "estimatedPriceUnavailable": "Non disponible",
    "estimatedPartial_one": "{{count}} produit reste à chiffrer ; le total affiché est partiel.",
    "estimatedPartial_other": "{{count}} produits restent à chiffrer ; le total affiché est partiel.",
    "continueDraft": "Continuer",
    "dataSaved": "Données du projet mises à jour",
    "desiredDate": "Date souhaitée",
    "detailDocuments": "Documents",
    "detailTimeline": "Suivi",
    "detailTitle": "Détail de la demande",
    "discardDraft": "Supprimer",
    "discardDraftConfirm": "Supprimer le brouillon",
    "discardDraftText": "« {{name}} » sera supprimé avec les photos et les lignes ajoutées. Cette action est irréversible.",
    "discardDraftTitle": "Supprimer ce brouillon ?",
    "draftDiscarded": "Brouillon supprimé.",
    "draftLabel": "Demande inachevée",
    "draftSaved": "Brouillon enregistré",
    "draftText": "Vous l’avez commencée sans l’envoyer.",
    "editData": "Modifier les données",
    "editLine": "Modifier la ligne",
    "emptyText": "Votre première liste de matériel apparaîtra ici une fois envoyée.",
    "emptyTitle": "Aucune demande pour le moment",
    "excludeLine": "Retirer de la liste",
    "excluded": "Exclue",
    "filesAdded": "Fichiers ajoutés",
    "filesReady_one": "{{count}} fichier prêt à être traité",
    "filesReady_other": "{{count}} fichiers prêts à être traités",
    "goToRequests": "Voir mes demandes",
    "humanNoteText": "Cette liste comprend les produits que vous avez vérifiés et les suggestions que vous avez acceptées.",
    "humanNoteTitle": "Atlas complétera également la solution",
    "inProgressProcessing": "Lecture de votre liste",
    "inProgressSubmitted": "Préparation du devis",
    "inProgressQuoteReview": "Un commercial vérifie le devis",
    "includeLine": "Inclure dans le devis",
    "itemsCount_one": "{{count}} article",
    "itemsCount_other": "{{count}} articles",
    "leaveAndContinue": "Quitter et continuer plus tard",
    "leaveDraft": "Quitter",
    "materialsNavigation": "Navigation des produits",
    "addMaterialsFirst": "Ajoutez au moins un produit ou un fichier pour continuer",
    "processWithAtlas": "Analyser avec Atlas",
    "linesDetected_one": "{{count}} ligne détectée",
    "linesDetected_other": "{{count}} lignes détectées",
    "listSubtitle": "Consultez l'état de tout ce que vous avez envoyé.",
    "listTitle": "Mes demandes",
    "paginationSummary": "{{from}}–{{to}} sur {{total}} demandes",
    "perPage": "Par page",
    "paginationAria": {
      "page": "Aller à la page {{page}}",
      "first": "Aller à la première page",
      "last": "Aller à la dernière page",
      "next": "Aller à la page suivante",
      "previous": "Aller à la page précédente"
    },
    "location": "Lieu d'installation",
    "locationPlaceholder": "Ville ou adresse",
    "manualEntry": "Saisir manuellement",
    "manualEntryHint": "Ajoutez les produits un par un",
    "manualHint": "Ajoutez nos produits ou activez Autres marques pour chercher des équivalences ligne par ligne.",
    "externalManufacturer": "Marque ext.",
    "otherBrands": "Autres marques",
    "externalCode": "Code/réf. externe",
    "equivalence": {
      "resolved": "Équivaut à {{product}} selon Atlas.",
      "resolvedDetail": "{{source}} → {{product}}",
      "searching": "Recherche des équivalences Atlas…",
      "noCandidates": "Aucun candidat homologué",
      "validated": "Validé",
      "proposal": "Proposition",
      "score": "Note {{score}}/100",
      "notFound": "Atlas ne dispose d’aucune équivalence homologuée.",
      "unavailable": "La table d’équivalences est inaccessible."
    },
    "fromCatalog": "Du catalogue",
    "fromCatalogHint": "Les données d’un article du catalogue ne se modifient pas ici. Pour le saisir à la main, effacez le code.",
    "catalogSearching": "Recherche dans le catalogue…",
    "catalog": {
      "ambiguous": "Plusieurs articles correspondent. Choisissez-en un dans la liste.",
      "notFound": "Absent du catalogue. Vous pouvez le décrire à la main.",
      "unavailable": "Impossible de consulter le catalogue. Remplissez la ligne à la main."
    },
    "manualTitle": "Liste manuelle de produits",
    "noCatalogResults": "Aucune correspondance dans le catalogue",
    "notes": "Remarques",
    "notesPlaceholder": "Ajoutez tout détail utile à prendre en compte…",
    "phaseFinishing": "Préparation de la liste pour vérification",
    "phaseValidatingResult": "Validation de la liste complète",
    "phaseIdentifying": "Identification des références et des quantités",
    "phasePreparing": "Préparation du document",
    "phaseReading": "Reconnaissance du texte",
    "processingCompleted": "{{percent}} % effectué",
    "processingErrorText": "Atlas n'a pas pu terminer l'analyse des fichiers. Vous pouvez réessayer avec les fichiers enregistrés ou en ajouter d'autres.",
    "processingErrorTitle": "Nous n'avons pas pu terminer l'analyse",
    "returnToPreviousReview": "Revenir à la liste précédente",
    "processingRemaining": "Atlas travaille toujours",
    "processingSavedText": "Vous ne perdrez pas les informations du projet.",
    "processingSavedTitle": "Votre demande a été enregistrée",
    "processingSubtitle": "La progression suit les données d’Atlas, avec des transitions graduelles entre les pourcentages. Sans nouvelle information, la dernière valeur reçue est conservée.",
    "processingGuardTitle": "Atlas doit terminer la liste",
    "processingGuardText": "La vérification s’ouvrira automatiquement lorsqu’Atlas aura identifié et enregistré une liste valide.",
    "processingQualityTitle": "Atlas vérifie la lecture",
    "processingQualityText": "La première lecture n’est pas assez fiable. Nous attendons une interprétation correcte sans afficher de données erronées.",
    "processingTitle": "Atlas analyse le fichier",
    "queueGlobalLimit_one": "En attente · Capacité globale : {{count}} analyse simultanée. Ce n’est pas une limite par client.",
    "queueGlobalLimit_other": "En attente · Capacité globale : {{count}} analyses simultanées. Ce n’est pas une limite par client.",
    "queueNoUserLimit": "En attente d’exécution. Votre utilisateur n’a pas de limite d’analyses simultanées.",
    "queueUserLimit": "En attente : chaque utilisateur peut lancer {{count}} analyses simultanées. Cette analyse démarrera automatiquement à la fin de l’une des vôtres.",
    "queueHighDemand": "La demande est actuellement élevée. Votre analyse démarrera dès qu’une place sera disponible (limite globale : {{count}}).",
    "queuePosition": "Position dans la file : {{position}}",
    "processingUpdateErrorTitle": "Impossible d’actualiser la progression",
    "processingUpdateErrorText": "Atlas continue de travailler. Nous vérifierons à nouveau automatiquement.",
    "sendingPhotoTitle": "Envoi de la photo à Atlas",
    "sendingPhotoSubtitle": "La numérisation est terminée. L’image est transmise de manière sécurisée pour démarrer sa lecture.",
    "photoModeTitle": "Photo de la liste",
    "photoModeHint": "Cadrez tous les produits et veillez à ce que le texte soit bien lisible.",
    "photoPreviewAlt": "Photo de la liste de produits",
    "openCamera": "Ouvrir l’appareil photo",
    "scanningPhoto": "Atlas analyse la photo",
    "projectData": "Informations sur le projet",
    "projectDataHint": "Ces informations vous aideront à retrouver la demande plus tard.",
    "projectName": "Nom ou référence du projet",
    "projectNamePlaceholder": "Ex. Rénovation entrepôt logistique Nord",
    "reactivateRequest": "Réactiver la demande",
    "reanalyze": "Réanalyser",
    "reactivatedMessage": "Demande réactivée",
    "readingText": "Nous reconnaissons les références et les quantités du document que vous avez envoyé. Vous pourrez le vérifier dès que ce sera terminé.",
    "readingTitle": "Atlas lit votre liste",
    "removeRow": "Supprimer la ligne",
    "requestOptions": "Options de la demande",
    "unidentifiedSummaryTitle": "Produits en attente",
    "unidentifiedSummaryCount": "{{count}} non identifiés",
    "visualSummaryTitle": "Lectures à confirmer",
    "visualReadingSaved": "Lecture confirmée",
    "visualIdentificationReady": "Lectures confirmées. Sélectionnez un produit en attente pour répondre aux questions d’Atlas.",
    "visualPreparingQuestions": "Lecture enregistrée. Atlas prépare les questions pour identifier les produits…",
    "visualSummaryCount": "{{count}} à confirmer",
    "visualSummaryHint": "Confirmez le texte et la quantité de chaque ligne. Atlas affichera ensuite les questions permettant de choisir les produits.",
    "identifyProduct": "Identifier le produit",
    "includedComponentLabel": "Accessoires inclus de série",
    "atlasIncludedAccessory": "Inclus · Atlas",
    "atlasCandidateProducts": "Options trouvées par Atlas",
    "atlasCandidateProductsHint": "Atlas a interprété le besoin et validé ces options dans le catalogue. Choisissez la bonne.",
    "atlasGuidedSelectionTitle": "Atlas vous aide à choisir",
    "atlasIdentityTitle": "Vérifier l’identification",
    "atlasIdentityHint": "Atlas doit préciser quel produit apparaît dans l’image, pas choisir ses caractéristiques.",
    "atlasIdentityField": "Code ou référence",
    "atlasIdentityQuestion": "Vérifiez le code ou la référence dans l’image et corrigez-le si nécessaire. Vous pouvez aussi rechercher le produit dans le catalogue.",
    "atlasIdentityPlaceholder": "Saisissez le code ou la référence et, si vous la connaissez, la marque",
    "atlasGuidedSelectionHint": "Sélectionnez les caractéristiques et nous afficherons uniquement le produit compatible.",
    "atlasReplacementTitle": "Alternatives trouvées par Atlas",
    "atlasReplacementHint": "Ce produit n’est plus disponible. Atlas a vérifié ces options comme remplacements possibles.",
    "discontinuedProduct": "Produit arrêté",
    "discontinuedCommercialReview": "Aucun remplacement direct n’est confirmé. Un commercial examinera cette ligne.",
    "discontinuedAlternativesAvailable": "Atlas a trouvé des alternatives compatibles. Vérifiez-les et sélectionnez la plus adaptée.",
    "currentProductRange": "gamme de produits actuelle",
    "atlasRackWaiting": "Atlas calcule l’espace nécessaire et prépare les racks compatibles. Vous n’avez pas besoin de sélectionner à nouveau les équipements.",
    "atlasRackSizingTitle": "Espace calculé par Atlas",
    "atlasRackEquipmentUnits": "Équipements : {{count}} U",
    "atlasRackReserveUnits": "Réserve : {{count}} U",
    "atlasRackVentilationUnits": "Ventilation : {{count}} U",
    "atlasRackMinimumUnits": "Minimum : {{count}} U",
    "atlasRackCompatibleSummary": "{{count}} racks compatibles de {{units}} U ou plus sont affichés",
    "atlasSelectionStep": "Étape {{step}}",
    "atlasPhoneLinesQuestion": "Combien de lignes téléphoniques analogiques devez-vous connecter à l’ONT ?",
    "atlasPhoneLinesHint": "Connexions RJ11 pour téléphones classiques.",
    "atlasPhoneLines_one": "1 ligne téléphonique",
    "atlasPhoneLines_other": "{{count}} lignes téléphoniques",
    "atlasNoPhoneLines": "Sans téléphonie",
    "atlasAnswerPlaceholder": "Saisissez la réponse",
    "atlasAnaloguePhoneLines_one": "1 ligne téléphonique analogique",
    "atlasAnaloguePhoneLines_other": "{{count}} lignes téléphoniques analogiques",
    "atlasAnaloguePhoneConnections": "connexions téléphoniques analogiques",
    "atlasAnalogueTelephony": "téléphonie analogique",
    "atlasChooseFormat": "Quel format vous faut-il ?",
    "atlasChooseUsers": "Combien d’utilisateurs doit-il prendre en charge ?",
    "atlasChoosePorts": "De combien de ports avez-vous besoin ?",
    "atlasChooseRackUnits": "Quelle hauteur vous faut-il ?",
    "atlasChoosePots": "De combien de ports téléphoniques avez-vous besoin ?",
    "atlasUsersUpTo": "Jusqu’à {{count}} utilisateurs",
    "atlasUsersRange": "De {{from}} à {{to}} utilisateurs",
    "atlasPorts": "{{count}} ports",
    "atlasRackUnits": "{{count}} U",
    "atlasPots": "{{count}} POTS",
    "atlasCompatibleProduct_one": "Produit compatible",
    "atlasCompatibleProduct_other": "Produits compatibles",
    "atlasProductCode": "Code {{code}}",
    "atlasSelectProduct": "Choisir",
    "atlasProductSelected": "Sélectionné",
    "atlasSearchOtherProduct": "Rechercher un autre produit du catalogue",
    "atlasHideCatalogSearch": "Masquer la recherche dans le catalogue",
    "atlasQuestionsTitle": "Information nécessaire pour choisir correctement",
    "recognitionRecommendationsTitle": "Recommandé par Atlas",
    "recognitionRecommendationsHint": "Compléments qu’Atlas juge nécessaires. Vous pourrez les valider à l’étape suivante.",
    "validateEquivalence": "Valider l’équivalence",
    "equivalenceValidated": "Équivalence validée",
    "pendingProductsFooter": "{{count}} produits restent à identifier",
    "pendingSuggestionsFooter_one": "1 produit suggéré par Atlas reste à confirmer",
    "pendingSuggestionsFooter_other": "{{count}} produits suggérés par Atlas restent à confirmer",
    "pendingEquivalencesFooter": "{{count}} équivalences restent à valider",
    "commercialReviewFooter_one": "1 produit sera soumis à une révision commerciale",
    "commercialReviewFooter_other": "{{count}} produits seront soumis à une révision commerciale",
    "reviewReadyFooter": "Révision terminée",
    "reviewNavigation": "Navigation de la révision",
    "reviewList": "Liste",
    "reviewSubtitle": "Contrôlez chaque ligne avant de demander le devis.",
    "visualReviewTitle": "Confirmez la lecture de l’image",
    "visualReviewConfirm": "Confirmer la lecture",
    "visualEditReading": "Modifier la lecture",
    "visualReviewConfirming": "Confirmation…",
    "visualLiteralDescription": "Texte lu dans l’image",
    "visualReviewUncertainties": "Données à vérifier",
    "visualTextOptions": "Lectures proposées par Atlas",
    "visualQuantityOptions": "Quantités proposées par Atlas",
    "visualUnitOptions": "Unités proposées par Atlas",
    "visualQuantityAlternatives": "Quantités possibles : {{values}}",
    "visualUncertainTokens": "Texte incertain : {{values}}",
    "visualAlternativeReadings": "Autres lectures possibles : {{values}}",
    "visualReviewReasonGeneric": "Atlas a trouvé des différences entre plusieurs lectures de cette ligne.",
    "visualReviewLineHint": "Confirmez ou corrigez d’abord la lecture. Atlas cherchera ensuite les options compatibles.",
    "atlasMoreQuestionsNeeded": "Atlas a besoin de précisions avant d’afficher les produits compatibles.",
    "saveDraft": "Enregistrer le brouillon",
    "searchCatalog": "Rechercher dans le catalogue",
    "changeProduct": "Changer de produit",
    "changeProductHint": "Recherchez par code ou référence et choisissez le produit. Seul l'article change : la quantité ou l'unité en attente se confirme toujours ici.",
    "saveProduct": "Enregistrer le produit",
    "searchCatalogHint": "Saisissez un code, une référence ou une partie de la description et choisissez le produit : les champs se remplissent seuls.",
    "searchPlaceholder": "Rechercher par référence ou projet",
    "secureText": "Elles serviront uniquement à préparer et à gérer votre devis.",
    "secureTitle": "Vos informations sont en sécurité",
    "sendDialogText": "Une fois envoyée, la liste ne pourra plus être modifiée. Vous serez averti dès que le devis sera prêt.",
    "sendDialogTitle": "Envoyer la demande à Atlas ?",
    "sendRequest": "Envoyer la demande",
    "sentEyebrow": "DEMANDE ENVOYÉE",
    "sentOn": "Envoyée le {{date}}",
    "sentRef": "Référence de la demande",
    "sentRedirect": "Ouverture automatique du détail dans {{seconds}} s.",
    "sentRedirectLabel": "secondes avant l’ouverture automatique du détail",
    "sentCountdown": "Le suivi Atlas s’affichera dans {{seconds}} s.",
    "sentCountdownLabel": "Secondes avant l’affichage du suivi Atlas",
    "sentText": "Atlas prépare votre devis. Nous vous préviendrons dès qu'il sera disponible.",
    "sentTitle": "Nous avons bien reçu votre demande",
    "startProcessing": "Lancer le traitement",
    "stepConfirm": "Confirmation",
    "stepValuation": "Valorisation",
    "stepData": "Informations",
    "stepDocuments": "Documents",
    "stepOf": "Étape {{current}} sur {{total}}",
    "stepProcessing": "Traitement",
    "stepReview": "Vérification",
    "stepRecommendations": "Recommandations",
    "recommendationsTitle": "Complétez votre solution",
    "recommendationsSubtitle": "Atlas a examiné l’ensemble pour détecter les produits, licences ou services manquants.",
    "recommendationsAnalyzing": "Atlas vérifie la solution",
    "recommendationsAnalyzingHint": "Compatibilités, capacités et éléments déjà inclus sont contrôlés pour éviter les doublons.",
    "recommendationsFailed": "Atlas n’a pas pu terminer les recommandations.",
    "recommendationsNeedInfo": "Atlas a besoin d’une précision",
    "recommendationsNeedInfoHint": "Ces réponses permettent de choisir la bonne variante et la bonne quantité.",
    "analyzeAnswers": "Analyser les réponses",
    "analyze": "Analyser",
    "imagesReady_one": "1 image prête à analyser",
    "imagesReady_other": "{{count}} images prêtes à analyser",
    "imagesAdded": "Images ajoutées",
    "addPhoto": "Ajouter une photo",
    "recommendationsFound_one": "1 recommandation Atlas",
    "recommendationsFound_other": "{{count}} recommandations Atlas",
    "recommendationPending": "À confirmer",
    "recommendationImportance": {
      "required": "Nécessaire",
      "recommended": "Recommandé",
      "optional": "Optionnel"
    },
    "recommendationCategory": {
      "prerequisite": "Prérequis technique",
      "license": "Licence",
      "compatibility": "Compatibilité",
      "accessory": "Accessoire",
      "service": "Service"
    },
    "recommendedQuantity": "Quantité suggérée : {{quantity}} {{unit}}",
    "addRecommendation": "Ajouter",
    "replaceRecommendation": "Remplacer",
    "discardRecommendation": "Écarter",
    "recommendationAdded": "Ajouté",
    "recommendationReplaced": "Remplacé",
    "replacementOf": "Remplace {{products}}",
    "addedByAtlas": "Ajouté sur recommandation d’Atlas",
    "replacedByAtlas": "Remplacé sur recommandation d’Atlas",
    "siteNumber": "Installation {{count}}",
    "recommendationDiscarded": "Écarté",
    "notKnownYet": "Je ne sais pas encore",
    "noRecommendations": "La solution est complète",
    "noRecommendationsHint": "Atlas n’a détecté aucun produit supplémentaire à examiner.",
    "recommendationsQuestionsFooter": "{{count}} réponses manquantes",
    "recommendationsPendingFooter": "{{count}} recommandations à examiner",
    "recommendationsReadyFooter": "Recommandations examinées",
    "takeAnotherPhoto": "Prendre une autre photo",
    "takePhoto": "Prendre une photo",
    "takePhotoHint": "Utilisez l'appareil photo de votre appareil",
    "titleData": "Parlez-nous du projet",
    "titleMaterials": "Documents du projet",
    "uploadFile": "Importer un fichier ou un tableur",
    "uploadFileHint": "PDF, Word, image, XLSX, XLS ou CSV · Word est converti en PDF",
    "dragFilesHint": "Vous pouvez aussi glisser un ou plusieurs fichiers ici pour les joindre.",
    "dropFilesHere": "Déposez les fichiers pour les joindre",
    "viewBudget": "Voir le devis",
    "recognisedSoFar": "Reconnus : {{count}}",
    "matchEquivalentFrom": "Vous demandiez {{marca}} ; nous proposons cet équivalent EK",
    "match": {
      "direct": "Lu tel quel",
      "equivalent": "Équivalent EK",
      "none": "Non identifié",
      "not_needed": "Pas nécessaire",
      "noEquivalent": "Pas d’équivalent EK",
      "noEquivalentLong": "Identifié comme {{marca}}, mais nous n’avons pas d’équivalent EK"
    },
    "showDiscardedRows": "Voir {{count}} lignes écartées du document",
    "hideDiscardedRows": "Masquer les lignes écartées",
    "discarded": {
      "headerRow": "En-tête du tableau",
      "documentTitle": "Titre du document",
      "partidaRow": "Poste dupliqué par son détail",
      "outsideNumberedTable": "Contenu hors du tableau des matériaux",
      "unreadableText": "Texte illisible",
      "otherScope": "Autre poste (main-d'œuvre, service ou génie civil)",
      "otherBrand": "Produit qui n'est pas Ek/Openetics",
      "otherBrandMaker": "Autre marque ({{brands}})",
      "otherBrandFamily": "Hors du catalogue Ek/Openetics ({{family}})",
      "documentText": "Texte du document (conditions, notes)"
    },
    "colProduct": "Produit",
    "colReference": "Référence",
    "colDescription": "Description",
    "documentTechnicalWarning": "Remarque : {{differences}}. Le produit identifié est conservé.",
    "documentTechnicalDifference": "le document indique « {{source}} » et le catalogue « {{catalog}} »",
    "colBrand": "Marque d’origine",
    "colQuantity": "Quantité",
    "colUnitPrice": "Prix",
    "colDiscount": "Remise",
    "colLineSubtotal": "Sous-total",
    "colStatus": "État",
    "convertedToEk": "Converti en EK",
    "groupResolved": "{{resolved}} produits reconnus sur {{count}}",
    "groupExcluded": "{{count}} exclus",
    "groupsDetected": "{{count}} postes détectés",
    "previewSelectCatalogProduct": "Sélectionnez un produit dans les résultats du catalogue pour modifier le code ou la référence.",
    "atlasSuggestion": "Suggéré par Atlas",
    "atlasSuggestionHint": "Alternative proposée par Atlas.",
    "reanalyzeDialogTitle": "Analyser à nouveau la demande ?",
    "reanalyzeDialogText": "Atlas relira les documents avec sa version actuelle. La nouvelle liste remplacera l'actuelle et les modifications faites pendant la révision seront perdues.",
    "documentReading": {
      "pending": "Lecture du document en attente de révision",
      "title": "Confirmer ou corriger la lecture",
      "help": "Choisissez une action pour chaque ligne ou avertissement. Une quantité vide restera en attente ; confirmer le texte n'identifie pas le produit.",
      "fragment": "Fragment en attente",
      "action": "Action de révision",
      "material": "Confirmer ou corriger le matériel",
      "ignore": "Écarter la ligne / prendre acte de l'avertissement",
      "text": "Texte lu",
      "quantity": "Quantité (vide si inconnue)",
      "unit": "Unité du document",
      "close": "Fermer",
      "save": "Enregistrer la révision"
    },
    "recommendationsNavigation": "Navigation des suggestions",
    "includedComponentReason": "ajoutés automatiquement avec le rack {{rack}}, sans frais.",
    "includedComponentReasonGeneric": "ajoutés automatiquement avec le rack, sans frais.",
    "atlasSuggestionLabel": "Alternative d’Atlas",
    "atlasSuggestionOtherBrand": "Alternative {{brand}} (autre marque)",
    "atlasSuggestionDifferences_one": "{{count}} différence",
    "atlasSuggestionDifferences_other": "{{count}} différences",
    "showDifferences": "Voir les différences",
    "hideDifferences": "Masquer les différences",
    "notInCatalogShort": "Aucun équivalent dans le catalogue",
    "originalBrandCaption": "Dans le document : {{value}}",
    "atlasRackNotCounted": "Non classés par Atlas pour le rack, donc non comptés : {{items}}",
    "atlasRackUnresolved": "Hauteur en U inconnue, non comptée : {{items}}. Le minimum ne compte que les équipements de hauteur connue.",
    "atlasRackExcluded": "N’occupent pas le rack : {{items}}",
    "atlasRackWaitingUnits": "Atlas ne connaît pas encore la hauteur en U de certains équipements de la liste et ne peut pas calculer l’espace du rack.",
    "atlasRackWaitingUnitsNamed": "Atlas ne peut pas calculer l’espace du rack : il n’a pas de hauteur en U vérifiée pour {{items}}.",
    "atlasRackSizingTitleCurrent": "Espace avec la liste actuelle",
    "atlasRackStale": "La liste a changé depuis le calcul d’Atlas (minimum {{minimum}} U) : l’espace a été recalculé avec les lignes actuelles et les hauteurs publiées par Atlas.",
    "atlasRackStaleNoRecompute": "La liste a changé depuis le calcul d’Atlas et ces chiffres peuvent ne plus être à jour : vérifiez l’espace avant de choisir le rack.",
    "atlasRackNotEvaluated": "Atlas n’a pas évalué ces lignes pour le rack (ajoutées ou modifiées dans la liste), elles ne sont donc pas comptées : {{items}}",
    "atlasRackPassive": "Éléments passifs de rack, non comptés par le calcul : {{items}}",
    "atlasRackRecommendedNotInList": "Atlas comptait aussi des équipements recommandés qui ne sont pas dans la liste : {{items}}",
    "atlasRackStaleSummary": "Avec la liste actuelle, il faut un rack de {{units}} U ou plus.",
    "atlasRackStaleSummaryMinimum": "Avec la liste actuelle, le minimum est de {{units}} U.",
    "atlasRackCandidateTooSmall": "Moins d’espace que le minimum actuel ({{units}} U).",
    "showAtlasNote": "Voir le détail",
    "hideAtlasNote": "Masquer le détail",
    "showFullNote": "Voir la note complète",
    "showLessNote": "Réduire la note",
    "includesStandardAccessories": "Inclut {{items}} de série, sans frais : ajouté automatiquement à la liste.",
    "rackCandidateIncludes": "Choisir ce rack ajoute {{items}} à la liste : fourni de série, sans frais.",
    "pdfProcessing": {
      "label": "Analyse de documents avec Atlas",
      "document": "Document",
      "reading": "Lecture",
      "catalog": "Catalogue",
      "upload": "Préparation de votre document",
      "read": "Lecture de votre document",
      "map": "Recherche dans le catalogue",
      "done": "Lecture terminée",
      "waiting": "En attente d’Atlas",
      "lines": "Lignes détectées",
      "matched": "Produits trouvés",
      "files_one": "{{count}} fichier",
      "files_other": "{{count}} fichiers",
      "sheet": "Feuille 1",
      "products": "Produits",
      "portal": "Portail client",
      "received": "Réception des données",
      "following": "Suivi de l’analyse",
      "sending": "Documents → Atlas",
      "returning": "Atlas → Portail",
      "exchange": {
        "prepare": "Préparation de vos documents",
        "send": "Atlas lit vos documents",
        "reason": "Atlas traite la liste",
        "match": "Atlas attribue les références",
        "receive": "Réception du résultat dans votre portail",
        "waiting": "En attente d’Atlas",
        "checking": "Atlas vérifie le résultat"
      },
      "atlas": {
        "prepare": "Réception des documents",
        "send": "Lecture de la liste",
        "reason": "Traitement de la liste",
        "match": "Attribution des références",
        "receive": "Liste prête",
        "waiting": "En attente",
        "checking": "Vérification du résultat"
      }
    },
    "copyReference": "Copier la référence de la demande",
    "copyReferenceFailed": "Impossible de copier la référence.",
    "validateAllAndContinue": "Tout valider et continuer",
    "validatingAll": "Validation…",
    "partidaOutsideCatalogTitle": "Produits hors Ek/Openetics",
    "partidaOutsideCatalogHint_one": "{{count}} produit du projet n’est pas au catalogue. Atlas propose une alternative équivalente lorsqu’il y en a une.",
    "partidaOutsideCatalogHint_other": "{{count}} produits du projet ne sont pas au catalogue. Atlas propose une alternative équivalente lorsqu’il y en a une.",
    "partidaUntitled": "Poste sans titre",
    "partidaMeasure": "Métré {{measure}}",
    "partidaProducts_one": "{{count}} produit",
    "partidaProducts_other": "{{count}} produits",
    "atlasScene": {
      "label": "Analyse d’Atlas",
      "document": "Document",
      "waiting": "En attente d’Atlas",
      "phase": {
        "upload": "Préparation de vos documents",
        "extract": "Atlas sépare chaque ligne du document",
        "enter": "Les lignes entrent dans Atlas",
        "master": "Atlas recherche chaque ligne dans le Master",
        "compose": "Atlas compose la liste",
        "ready": "Liste prête",
        "handoff": "Ouverture de votre liste"
      },
      "atlas": {
        "upload": "en attente",
        "extract": "lecture",
        "enter": "réception",
        "master": "consultation du Master",
        "compose": "composition",
        "ready": "prête",
        "handoff": "prête"
      },
      "master": {
        "searching": "Consultation du Master",
        "done": "Composition de la liste",
        "badge": "Master",
        "review": "Vérification…"
      },
      "list": {
        "title": "Liste",
        "ready": "Votre liste",
        "chip": "Prête"
      },
      "steps": {
        "upload": "Envoi",
        "extract": "Extraction",
        "enter": "Vers Atlas",
        "master": "Master",
        "compose": "Liste",
        "portal": "Portail"
      },
      "voice": {
        "upload": "Réception de votre document",
        "extract": "Lecture de chaque ligne",
        "enter": "Réflexion",
        "master": "Recherche dans le Master",
        "compose": "Composition de votre liste",
        "ready": "Prêt",
        "handoff": "Prêt",
        "waiting": "J'attends mon tour"
      }
    }
  },
  "requestStatus": {
    "in_progress": "En cours",
    "quote_rejected": "Refusée lors de la validation commerciale",
    "submission_blocked": "Envoi bloqué",
    "draft": "Brouillon",
    "processing": "Lecture de la liste",
    "review": "En attente de vérification",
    "submitted": "Devis en préparation",
    "quote_review": "Devis en cours de revue",
    "quote_validated": "Devis validé · en attente d’acceptation",
    "quote_partially_validated": "Devis partiellement validé · en attente de vérification",
    "quote_won": "Devis gagné",
    "quote_lost": "Devis perdu",
    "quoted": "Devis disponible",
    "cancelled": "Annulée",
    "failed": "Erreur de lecture",
    "ordering": "Passage en commande",
    "ordered": "Commande créée",
    "order_blocked": "Commande non confirmée"
  },
  "support": {
    "title": "Assistance",
    "subtitle": "Dites-nous ce dont vous avez besoin, nous vous répondrons par e-mail.",
    "topic": "Objet",
    "topicRequest": "Question sur une demande",
    "topicBudget": "Question sur un devis",
    "topicAccount": "Problème avec mon compte",
    "topicOther": "Autre sujet",
    "relatedRef": "Référence concernée",
    "message": "Message",
    "messagePlaceholder": "Décrivez votre question avec le plus de détails possible…",
    "send": "Envoyer la question",
    "sentTitle": "Nous avons bien reçu votre message",
    "sentText": "Nous répondrons à l'adresse de votre compte en moins de 24 heures ouvrées.",
    "received": "Message envoyé"
  },
  "theme": {
    "label": "Thème",
    "light": "Clair",
    "dark": "Sombre",
    "system": "Selon le système"
  },
  "unitReview": {
    "processing": "Atlas confirme l’unité…",
    "pending": "Unité à confirmer",
    "line": "Composant",
    "sourceGroup": "Poste d’origine",
    "confirm": "Confirmer l’unité",
    "change": "Corriger l’unité",
    "title": "Confirmer l’unité de mesure",
    "original": "Unité d’origine : {{unit}}",
    "source": "Page/feuille {{page}} · ligne {{row}} · code {{code}}",
    "quantityUnchanged": "Seule l’unité de cette ligne est confirmée. La quantité, les autres lignes et le groupe source restent inchangés.",
    "choose": "Choisir une unité admise",
    "separateAction": "Confirmez ou corrigez l’unité via l’action dédiée de la ligne ; choisir un produit ne la confirme pas.",
    "blocked": "Confirmez les unités en attente des lignes de matériel avant de continuer.",
    "returnToReview": "Vérifier les unités",
    "orderBlocked": "La commande ne peut pas être acceptée tant que des unités restent à confirmer. Vérifiez la demande associée.",
    "notSynchronized": "L’unité n’a pas été appliquée : Atlas n’a pas confirmé le changement et la ligne reste à confirmer. Confirmez-la à nouveau."
  },
  "units": {
    "ud": "u",
    "m": "m",
    "kg": "kg",
    "h": "h",
    "box": "boîte"
  },
  "atlasPending": {
    "title": "En attente d'Atlas",
    "help": "Sélectionnez un produit pour répondre à Atlas et compléter son identification.",
    "fullDescription": "Description complète"
  },
  "installation": {
    "comingSoon": "Prochainement",
    "describeTitle": "Décrivez votre installation à Atlas",
    "describeHint": "Atlas prépare le matériel à partir de vos besoins",
    "steps": {
      "description": "Votre installation",
      "details": "Détails",
      "materials": "Matériel",
      "suggestions": "Suggestions",
      "technicalReview": "Vérification technique",
      "confirmation": "Confirmation"
    },
    "phases": {
      "revision": "Vérification du matériel",
      "confirmar": "Confirmation du devis"
    },
    "newRequestNotice": "Cette demande contient déjà du matériel ou des documents. En envoyant la description, nous créerons une autre demande avec les mêmes informations de projet et conserverons celle-ci.",
    "restartNotice": "Si vous renvoyez la description, Atlas lancera une nouvelle analyse et vous redemandera les détails nécessaires.",
    "tellUs": "Dites-nous ce dont vous avez besoin",
    "descriptionLabel": "Votre installation",
    "descriptionHelp": "Décrivez l'objectif, les dimensions, les équipements existants et toute exigence à prendre en compte.",
    "useExample": "Utiliser un exemple de description",
    "example": "Je souhaite améliorer le Wi-Fi d'un bureau de plain-pied avec quatre pièces. J'ai déjà un routeur et le câblage réseau. J'ai besoin de points d'accès pour une vingtaine d'utilisateurs et je veux savoir quels autres équipements sont nécessaires.",
    "proposalTitle": "Votre proposition de matériel",
    "technicalPendingTitle": "Vérifications techniques en attente",
    "atlasUpdatePendingTitle": "En attente d'une mise à jour d'Atlas",
    "resolveHint": "Vous n'avez pas besoin de répondre à nouveau. Atlas doit compléter la sélection avec la documentation et les alternatives disponibles.",
    "noMoreQuestions": "Atlas n'a plus de questions pour vous pour le moment. Votre demande est enregistrée et vous pouvez la reprendre depuis l'accueil.",
    "previewNotice_one": "Ce matériel est un aperçu. Vous pourrez le confirmer, le modifier ou le retirer quand Atlas aura terminé ses vérifications.",
    "previewNotice_other": "Ces {{count}} articles sont un aperçu. Vous pourrez confirmer, modifier ou retirer chacun d'eux quand Atlas aura terminé ses vérifications.",
    "correctDescription": "Corriger la description",
    "blockersNotice": "Ces vérifications restent à faire avant de pouvoir afficher une proposition prête à être confirmée.",
    "atlasDetails": "Voir les détails d'Atlas",
    "noProposalYet": "Aucune proposition n'est encore disponible. Consultez le statut pour vérifier s'il y a du nouveau.",
    "clarifyTitle": "Précisons votre installation",
    "clarifyHint": "Touchez chaque sujet pour répondre étape par étape. Nous enverrons ensuite vos réponses à Atlas.",
    "retryableFailure": "Atlas n'a pas pu terminer l'analyse à cause d'une interruption temporaire. Vos réponses sont enregistrées. Vous pouvez réessayer sans recommencer.",
    "failure": "Atlas n'a pas pu compléter la proposition. Vous pouvez revoir la description et réessayer.",
    "plannerUnavailableTitle": "Atlas n’a pas pu planifier l’installation pour le moment",
    "plannerUnavailableText": "Votre description est conservée. Vous pouvez réessayer dans quelques minutes ou remplir vous-même la liste des produits ; Atlas les identifiera dans le catalogue lorsque vous continuerez.",
    "plannerRetry": "Réessayer",
    "awaitingConfirmation": "En attente de votre confirmation",
    "whyComponents": "Pourquoi ces composants",
    "youDecideTitle": "Vous décidez de ce qui entre dans le devis",
    "youDecideText": "Nous réglerons d'abord les détails manquants. Vous pourrez ensuite vérifier le matériel, comprendre son choix et ajouter des améliorations facultatives.",
    "yourDescription": "Votre description",
    "atlasObservations": "Remarques d'Atlas",
    "referenceFiles": "Fichiers de référence",
    "optionalTag": "(facultatif)",
    "confirmedCount": "{{confirmed}} articles sur {{total}} confirmés.",
    "provisionalCount_one": "1 article provisoire · En attente d'Atlas",
    "provisionalCount_other": "{{count}} articles provisoires · En attente d'Atlas",
    "detailsCompleted": "{{done}} détails sur {{total}} complétés",
    "retrying": "Nouvelle tentative d'analyse…",
    "resolving": "Vérification avec Atlas…",
    "checking": "Consultation…",
    "preparingAction": "Préparation de la proposition…",
    "retry": "Relancer l'analyse",
    "resolve": "Résoudre avec Atlas",
    "checkStatus": "Consulter le statut",
    "sendDescription": "Envoyer la proposition",
    "reviewDescription": "Revoir la description",
    "sendAnswers": "Envoyer les réponses",
    "reviewTopic": "Revoir : {{topic}}",
    "clarifyTopic": "Préciser : {{topic}}",
    "answersSaved": "Réponses enregistrées. Vous pouvez les revoir.",
    "stepsToClarify_one": "1 étape pour le préciser",
    "stepsToClarify_other": "{{count}} étapes pour le préciser",
    "tapToAnswer": "Touchez pour répondre",
    "completed": "Terminé",
    "pending": "En attente",
    "clarifyDetail": "Précisez ce détail",
    "closeKeepAnswers": "Fermer et conserver les réponses",
    "previous": "Précédent",
    "backToQuestions": "Retour aux questions",
    "next": "Suivant",
    "saveAnswers": "Enregistrer les réponses",
    "selectOption": "Sélectionnez une option",
    "quantity": "Quantité",
    "yourAnswer": "Votre réponse",
    "optionalAnswer": "Facultatif. Vous pouvez continuer sans répondre.",
    "whyAtlasAsks": "Pourquoi Atlas pose-t-il cette question ?",
    "preparingTitle": "Atlas prépare votre installation",
    "preparingText": "Nous examinons votre description et les produits du catalogue.",
    "preparingProgress": "Atlas prépare la proposition",
    "preparingLeave": "Vous pouvez quitter et revenir à cette demande pour continuer.",
    "columns": {
      "code": "Code",
      "reference": "Référence",
      "name": "Description courte",
      "quantity": "Quantité",
      "actions": "Actions"
    },
    "proposalTableLabel": "Matériel proposé par Atlas",
    "allRemoved": "Vous avez retiré tout le matériel. Revenez à votre description pour préparer une autre proposition.",
    "confirmItem": "Confirmer {{name}}",
    "editItem": "Modifier {{name}}",
    "itemConfirmed": "{{name}} confirmé",
    "remove": "Retirer",
    "removeItem": "Retirer {{name}}",
    "userCatalogReason": "Produit que vous avez sélectionné dans le catalogue. Son adéquation à l'installation reste à vérifier.",
    "referencesHint": "Ajoutez des plans, des photos ou des documents pour aider Atlas à comprendre l'installation.",
    "removeFile": "Retirer le fichier",
    "savingReferences": "Enregistrement des fichiers de référence",
    "referencesLocked": "Pour modifier ces fichiers, relancez l'analyse de la proposition.",
    "changeFiles": "Modifier les fichiers",
    "savingFiles": "Enregistrement des fichiers…",
    "attachFiles": "Joindre des fichiers",
    "attachReferences": "Joindre des fichiers de référence",
    "referencesLimits": "PDF, JPG, PNG ou WebP. Jusqu'à 5 fichiers, 10 Mo par fichier et 20 Mo au total.",
    "changeReferencesTitle": "Modifier les fichiers de référence",
    "changeReferencesText": "La description et les fichiers seront conservés. Après les avoir modifiés, vous devrez renvoyer la proposition ; Atlas l'analysera à nouveau et les réponses de l'analyse précédente ne seront pas utilisées.",
    "verificationTitle": "Vérification technique d'Atlas",
    "verified": "Atlas a vérifié cette liste. Vous pouvez maintenant consulter le récapitulatif et confirmer la demande.",
    "verifying": "Atlas vérifie les produits, les quantités et leur compatibilité…",
    "verificationQuestions": "Atlas a besoin de ces détails pour valider votre installation",
    "verificationBlocked": "La vérification ne permet pas encore de confirmer. Consultez les remarques d'Atlas et corrigez la liste ou complétez les détails.",
    "verificationIntro": "Avant la confirmation, Atlas vérifiera l'installation avec la liste que vous avez revue et les améliorations sélectionnées.",
    "reviewMaterials": "Revoir le matériel",
    "listVerified": "Liste vérifiée",
    "verificationRunning": "Vérification en cours",
    "verificationPending": "En attente de vérification",
    "verifyWithAtlas": "Vérifier avec Atlas",
    "suggestionsTitle": "Complétez votre installation",
    "suggestionsHint": "Consultez les suggestions d'Atlas et choisissez celles que vous voulez ajouter à votre proposition.",
    "backToProposal": "Retour à la proposition",
    "observations": {
      "analysisNeedsInput": "Complétez les détails dont Atlas a besoin pour vérifier l'installation.",
      "lineRevision": "Revoyez le matériel : Atlas a détecté des composants nécessaires ou des incompatibilités à résoudre.",
      "mandatoryDependencies": "Il manque des composants nécessaires au fonctionnement de l'installation. Consultez les suggestions d'Atlas.",
      "catalogChanged": "Le catalogue a changé. Revoyez les produits avant de valider à nouveau l'installation.",
      "catalogMismatch": "Atlas doit corriger les références ou les unités qui ne correspondent pas au catalogue avant d'afficher le matériel.",
      "pending": "Une vérification d'Atlas est en attente.",
      "reviewNeeded": "Atlas a besoin que vous revoyiez l'installation avant de continuer."
    },
    "plannerReadAsList": "Faire lire comme une liste par Atlas",
    "typedTextPlannerNotice": "Atlas a lu votre texte et il décrit une installation, pas une liste de produits : il prépare la proposition d’installation à partir de cette même description.",
    "materialListBlockedTitle": "Nous n’avons pas pu lire la liste dans cette demande",
    "materialListBlockedText": "Votre liste est conservée. Cette demande a changé pendant que vous l’écriviez et ne peut pas recevoir la liste pour le moment. Vous pouvez faire lire la liste par Atlas dans une nouvelle demande avec les mêmes données du projet ou saisir les produits à la main.",
    "materialListNewRequest": "La lire dans une nouvelle demande"
  },
  "adaltra": {
    "portal": "Portail client",
    "workspace": "Votre espace de travail",
    "helpTitle": "À votre écoute",
    "helpBody": "Nous vous aidons avec vos demandes et vos devis.",
    "helpAction": "Contacter le support",
    "skip": "Aller au contenu",
    "openMenu": "Ouvrir le menu",
    "closeMenu": "Fermer le menu",
    "navigation": "Navigation principale",
    "activity": "Votre portail",
    "account": "Votre compte",
    "search": "Rechercher des demandes",
    "searchHint": "Rechercher une demande par nom ou référence…",
    "noResults": "Aucune section trouvée",
    "welcome": "Bienvenue sur votre portail",
    "client": "Client",
    "team": "Équipe ADALTRA",
    "navigate": "Chercher une rubrique",
    "navigateHint": "Aller à une rubrique…",
    "searchSubmit": "Rechercher des demandes",
    "expandSidebar": "Déployer le menu",
    "collapseSidebar": "Replier le menu"
  },
  "pdfLab": {
    "nav": "Lecture de PDF",
    "title": "Lisez votre document avant de l’envoyer",
    "eyebrow": "Documents / Atlas",
    "subtitle": "Extrayez le texte, vérifiez les produits et préparez les données utiles à Atlas.",
    "drop": "Déposez vos documents ici",
    "formats": "PDF, JPG et PNG · 15 Mo par fichier et 60 pages au total",
    "select": "Sélectionner les documents",
    "forceOcr": "Forcer l’OCR sur toutes les pages",
    "readAgain": "Relire",
    "progressOcr": "Reconnaissance OCR de la page {{page}}…",
    "progressText": "Extraction du texte de la page {{page}}…",
    "tooLarge": "Le fichier est vide ou dépasse 15 Mo.",
    "tooManyPages": "Les documents dépassent 60 pages. Divisez le fichier.",
    "tooManyPixels": "La page est trop grande pour le navigateur.",
    "unsupported": "Sélectionnez un PDF, JPG ou PNG valide.",
    "unreadable": "Impossible de lire le document. Vérifiez son intégrité et son mot de passe.",
    "pageCount": "{{count}} pages",
    "lineCount": "{{count}} produits lus",
    "ocrCount": "{{count}} pages avec OCR",
    "reviewHint": "Vérifiez les références, descriptions, quantités et unités. L’original reste sur votre appareil. Aucun PDF n’est envoyé à Atlas.",
    "products": "Produits du document",
    "identify": "Vérifier dans le catalogue",
    "identifying": "Consultation du catalogue…",
    "include": "Inclure",
    "reference": "Référence",
    "description": "Description",
    "quantity": "Quantité",
    "unit": "Unité",
    "brand": "Marque",
    "status": "Identification",
    "exact": "Correspondance exacte",
    "approximate": "Candidats à vérifier",
    "unmatched": "Aucune correspondance",
    "unavailable": "Catalogue indisponible",
    "pending": "Non vérifié",
    "pages": "Texte original par page",
    "page": "Page {{page}}",
    "embedded": "Texte du PDF",
    "sourceText": "Texte original",
    "onlyLines": "Préparer uniquement les lignes sélectionnées",
    "preparedText": "Texte à envoyer à Atlas",
    "textCount": "{{count}} caractères · Le contenu n’est jamais tronqué automatiquement.",
    "download": "Télécharger le texte",
    "send": "Envoyer le texte vérifié à Atlas",
    "sending": "Envoi du texte…",
    "textUnsupported": "Cette connexion Atlas ne prend pas encore en charge le texte. Vous pouvez le télécharger. Le PDF ne sera pas envoyé à sa place.",
    "textTooLong": "Le texte dépasse les limites de cette connexion Atlas. Vérifiez la sélection ou préparez plusieurs demandes.",
    "sendError": "Impossible d’envoyer le texte. Vérifiez l’état de la demande avant de réessayer.",
    "newDraftRequired": "Pour utiliser la lecture PDF, ouvrez une nouvelle demande sans documents ni produits. La demande actuelle est conservée.",
    "pageCount_one": "1 page",
    "lineCount_one": "1 produit lu",
    "ocrCount_one": "1 page avec OCR",
    "editLine": "Corriger un produit lu",
    "reviewTitle": "Vérifiez les produits lus",
    "reviewSubtitle": "Vérifiez les quantités et références. Corrigez chaque produit avant de continuer.",
    "uploadTitle": "Ajoutez vos documents",
    "uploadSubtitle": "Le texte et les pages numérisées seront lus avant leur envoi à Atlas.",
    "changeMethod": "Changer de méthode",
    "textCountShort": "{{count}} caractères"
  },
  "preferences": {
    "title": "Préférences",
    "subtitle": "Choisissez les notifications à recevoir et leur canal.",
    "notifications": "Types de notifications",
    "description": "Vos préférences sont enregistrées dans votre compte et appliquées sur tous vos appareils.",
    "deliveryHint": "Les e-mails et les notifications push dépendent des canaux activés par votre entreprise. Pour recevoir les push, activez aussi les notifications sur cet appareil. Les e-mails d’accès et de sécurité restent actifs.",
    "saved": "Préférences enregistrées.",
    "channels": {
      "email": "E-mail",
      "portal": "Portail",
      "push": "Push"
    },
    "categories": {
      "requests": {
        "title": "Demandes",
        "description": "Envoi, réception et fin de la lecture."
      },
      "budgets": {
        "title": "Devis",
        "description": "Disponibilité, révisions et changements de statut."
      },
      "reminders": {
        "title": "Rappels",
        "description": "Rappels pour examiner les devis en attente."
      },
      "incidents": {
        "title": "Incidents",
        "description": "Erreurs de lecture ou de préparation du devis."
      },
      "updates": {
        "title": "Actualités et autres notifications",
        "description": "Communications générales et notifications internes."
      }
    }
  },
  "twoFactor": {
    "title": "Vérification en deux étapes",
    "body": "Nous avons envoyé un code à 6 chiffres à",
    "codeLabel": "Code de vérification",
    "submit": "Vérifier et se connecter",
    "notReceived": "Vous ne l’avez pas reçu ?",
    "resend": "Renvoyer",
    "resendIn": "Renvoyer ({{time}})",
    "expired": "La session de vérification a expiré. Connectez-vous à nouveau."
  },
  "adaltraProfile": {
    "roles": {
      "client": "Client",
      "commercial": "Commercial",
      "manager": "Gestionnaire",
      "admin": "Administrateur",
      "orders": "Commandes"
    },
    "protection": "Votre compte, protégé",
    "protectionHint": "Vérification en deux étapes par e-mail avec un code à usage unique.",
    "devicesHint": "Les navigateurs vérifiés peuvent être mémorisés pendant 30 jours. Vous pouvez retirer cette confiance.",
    "forgetDevices": "Oublier les appareils",
    "devicesRevoked": "La confiance des appareils a été retirée.",
    "passwordHint": "Modifiez votre mot de passe pour protéger votre compte."
  },
  "stock": {
    "customerOrdersTitle": "Commandes clients en attente de livraison",
    "reportedDate": "Date communiquée : {{value}}",
    "customerOrdersCount": "Nombre de commandes communiqué : {{value}}",
    "customerOrdersUnavailable": "Détail des commandes indisponible",
    "customerOrdersEmpty": "La liste reçue ne contient aucune commande en attente.",
    "orderCustomer": "Client",
    "customerOrderNumber": "N° commande client",
    "orderDate": "Date de commande",
    "deliveryDate": "Date de livraison",
    "orderQuantity": "Quantité",
    "explanation": "Voir l’explication reçue",
    "ordersAndCommitments": "Commandes et engagements",
    "pendingCustomers": "Livraisons clients en attente",
    "supplierOrders": "En commande fournisseur",
    "totalCommitted": "Total engagé",
    "remainingAfterRequest": "Restant après l’opération",
    "warehouses": "Stock physique par entrepôt",
    "warehouse": "Entrepôt",
    "warehouseUnavailable": "Détail par entrepôt indisponible",
    "supplyArrivals": "Arrivées fournisseurs prévues",
    "purchaseOrdersCount": "Commandes fournisseurs : {{value}}",
    "expectedDate": "Date prévue",
    "purchaseOrder": "Commande",
    "noArrivalDate": "Aucune date prévue",
    "nextArrival": "Prochaine arrivée : {{value}}",
    "noIndicator": "Sans indicateur",
    "column": "Stock",
    "available": "Disponible : {{value}}",
    "unknown": "Inconnu",
    "not_queried": "Stock non consulté",
    "unavailable": "Stock indisponible",
    "not_applicable": "Sans objet",
    "physical": "Physique",
    "virtual": "Virtuel",
    "committed": "Total engagé",
    "checkedAt": "Consulté (heure espagnole) : {{value}}",
    "requested": "Contexte de consultation : {{value}} {{unit}}",
    "notComparable": "La comparaison avec la quantité demandée n’est pas vérifiée.",
    "reason": "Motif : {{value}}",
    "informational": "À titre informatif. Ne réserve aucun produit et ne garantit pas la livraison.",
    "details": "Voir le détail du stock. {{summary}}",
    "green": "Indicateur vert Atlas",
    "amber": "Indicateur orange Atlas",
    "red": "Indicateur rouge Atlas",
    "article": "Article",
    "requestedColumn": "Quantité demandée",
    "physicalVirtual": "Stock physique / virtuel",
    "committedColumn": "Total engagé",
    "availableColumn": "Disponible effectif",
    "indicatorColumn": "Indicateur",
    "dialogTitle": "Stock du produit",
    "minimumPurchase": "Quantité minimale d'achat : {{value}}",
    "minimumPurchasePackaging": "Quantité minimale d'achat : {{value}} (conditionnement {{packaging}})",
    "minimumPurchaseShort": "Min. {{value}}",
    "metric": "Donnée",
    "checking": "Vérification du stock…",
    "multipleOrders": "Plusieurs commandes : {{value}}",
    "yes": "Oui",
    "no": "Non",
    "level": "Niveau : {{value}}",
    "sharedProductTotal": "Le voyant et le stock restant concernent le total de ce produit dans la liste, sans répartition par ligne.",
    "stale": "La consultation a expiré. Actualisez le stock pour obtenir des données à jour.",
    "purchaseBasisUnknown": "L’unité ou la base d’achat du produit n’a pas pu être vérifiée.",
    "identityUnverified": "Le produit n’a pas pu être vérifié dans le catalogue.",
    "sourceUnavailable": "Le service de stock est actuellement indisponible.",
    "reasonUnknown": "Atlas n’a pas pu vérifier un stock à jour."
  },
  "stockSearch": {
    "productImage": "Image de {{reference}}",
    "imageUnavailable": "Image indisponible",
    "hint": "Demandes ou stock par code / référence…",
    "label": "Rechercher des demandes ou le stock produit",
    "requests": "Rechercher des demandes avec ce texte",
    "not_found": "Saisissez le code ou la référence complète du produit pour consulter son stock.",
    "ambiguous": "Cette référence correspond à plusieurs produits. Saisissez le code complet.",
    "unavailable": "Impossible de consulter le produit. Veuillez réessayer."
  },
  "closedOrder": {
    "confirmTitle": "Confirmer la commande",
    "confirmSubtitle": "Vérifiez la commande finalisée avant de l’envoyer à Atlas. Aucune recommandation ne sera ajoutée et les quantités resteront inchangées.",
    "stockNotice": "Atlas signale des limites de stock pour certains produits. Ouvrez leurs indicateurs pour consulter le détail ; vous pouvez envoyer la commande sans modifier les articles ni les quantités. Le stock est informatif et ne réserve pas de matériel.",
    "send": "Envoyer à Atlas",
    "dialogTitle": "Envoyer cette commande à Atlas ?",
    "dialogText": "La liste vérifiée sera envoyée sans ajouter de recommandations. Vérifiez les articles et les quantités avant de confirmer.",
    "reviewSubtitle": "Vérifiez les articles et quantités de la commande avant de l’envoyer à Atlas.",
    "reviewedNote": "Cette commande contient uniquement les articles et quantités de la liste vérifiée."
  },
  "productThumbnail": {
    "image": "Image de {{reference}}",
    "unavailable": "Image du produit indisponible"
  },
  "customerOrder": {
    "action": "Gagné et passer en commande",
    "dialogTitle": "Marquer comme gagné et passer en commande ?",
    "dialogText": "Atlas enverra {{ref}} à Ada-quote, marquera le devis comme GAGNÉ et le convertira en COMMANDE avec le client, l’adresse, la date de livraison et le numéro de commande de l’étape 1. Cette action crée une commande réelle.",
    "retry": "Réessayer",
    "confirmedDetail": "Commande {{order}} · Devis {{quote}}",
    "providerError": "Réponse d’Ada-quote : {{code}}",
    "state": {
      "requested": "Préparation de la commande…",
      "submission_failed": "La demande n’a pas pu être envoyée",
      "pending_creation": "Création du devis dans Ada-quote…",
      "sending": "Passage en commande…",
      "confirmed": "Devis gagné et passé en commande",
      "rejected": "Ada-quote a refusé la commande",
      "uncertain": "La commande n’a pas pu être confirmée"
    },
    "refresh": "Actualiser l’état",
    "processingTitle": "Passage en commande",
    "processingText": "Atlas marque le devis comme gagné et crée la commande dans Ada-quote.",
    "processingHint": "Vous pouvez fermer cette page : la commande continue.",
    "step": {
      "sending": "Envoi de la demande à Atlas",
      "quote": "Préparation du devis dans Ada-quote",
      "won": "Devis marqué comme gagné",
      "order": "Création de la commande",
      "pack": "Préparation de la commande",
      "send": "Envoi de la commande à MTR",
      "wait": "En attente de la confirmation de MTR…"
    },
    "orderLabel": "Commande",
    "quoteLabel": "Devis",
    "totalLabel": "Total",
    "deliveryLabel": "Livraison",
    "customerOrderNumberLabel": "Commande client",
    "stamp": "GAGNÉ"
  },
  "maintenance": {
    "banner": "Atlas est en maintenance. Vous pouvez créer des demandes et téléverser des documents : en cliquant sur « Analyser », elles seront mises en file d’attente et traitées automatiquement ensuite.",
    "until": "Prévu jusqu’à {{time}}.",
    "title": "Mode maintenance",
    "active": "Actif",
    "inactive": "Désactivé",
    "description": "Lorsqu’il est actif, « Analyser » met les demandes en file d’attente et Atlas ne commence aucune nouvelle lecture ; celles en cours se terminent. À sa désactivation, la file est envoyée automatiquement dans l’ordre. Il se désactive seul au bout de 2 heures.",
    "since": "Actif depuis {{time}}",
    "estimate": "prévu jusqu’à {{time}}",
    "expires": "se désactive seul à {{time}}",
    "message": "Message pour les utilisateurs (facultatif)",
    "minutes": "Durée estimée (min)",
    "processing_one": "{{count}} lecture en cours",
    "processing_other": "{{count}} lectures en cours",
    "queued_one": "{{count}} demande en file",
    "queued_other": "{{count}} demandes en file",
    "turnOn": "Activer la maintenance",
    "turnOff": "Désactiver et envoyer la file",
    "queuedTitle": "Demande en file d’attente",
    "queuedText": "Atlas est en maintenance. Votre demande est enregistrée dans la file et sera envoyée automatiquement à Atlas dès la fin ; nous vous préviendrons lorsque le traitement commencera. Vous pouvez fermer cet écran.",
    "queuedHome": "Aller à l’accueil"
  }
}
